/*-----------------------------------------------*
 * Architecture
 *
 * SegmentList
 * - collection of line segments
 * - segments endpoints in x,y coordinates
 * - generated from TriGridData
 * - generated by TriGrid
 * - generates PolygonList
 * PolygonList
 * - collection of polygons
 * - generated from SegmentList
 *-----------------------------------------------*/

/*-----------------------------------------------*
 * Configuration Values
 *-----------------------------------------------*/
var ANGLE_TOLERANCE = 100;
var NORMAL_TOLERANCE = 1000;

/*-----------------------------------------------*
 * 
 *-----------------------------------------------*/
var Debug_log = function(str)
{
	console.log(str);
}

var Debug_assert = function(str)
{
	console.log("ASSERT: " + str);
}


/*-----------------------------------------------*
 * Major Components
 * 
 * MathUtil (API)
 * SegmentList (API)
 * Polygon List (API)
 *-----------------------------------------------*/


// Transform

function Transform(srcBounds, dstBounds)
{
    this.scale = {x:1.0, y:1.0};
    this.offset = {x:0, y:0};
    
    if (srcBounds != undefined && dstBounds != undefined)
    	this.CalcMappingTransform(srcBounds, dstBounds);
}

Transform.prototype.Clone = function()
{
	var t = new Transform();
	
	t.scale.x = this.scale.x;
	t.scale.y = this.scale.y;
	t.offset.x = this.offset.x;
	t.offset.y = this.offset.y;
	return t;
}

Transform.prototype.setOffset = function(offsetX, offsetY)
{
    this.offset = {x:offsetX, y:offsetY};
}

Transform.prototype.scaleBy = function(scaleX, scaleY)
{
	this.scale.x *= scaleX;
	this.scale.y *= scaleY;
    this.offset.x *= scaleX;
    this.offset.y *= scaleY;
}

Transform.prototype.invertVertical = function()
{
	this.scale.y = -this.scale.y;
}


Transform.prototype.xfrm = function(pt)
{
	return {x:(pt.x * this.scale.x + this.offset.x), y:(pt.y * this.scale.y + this.offset.y)};
}

Transform.prototype.scaleNum = function(num)
{
	//console.log("num:" + num + ", type:" + typeof(num) + ", scale.x:" + this.scale.x + ", scale.y:" + this.scale.y);
	return num * (Math.abs(this.scale.x) + Math.abs(this.scale.y))/2;
}

Transform.prototype.reverse_scaleNum = function(num)
{
	//console.log("num:" + num + ", type:" + typeof(num) + ", scale.x:" + this.scale.x + ", scale.y:" + this.scale.y);
	return num / ((Math.abs(this.scale.x) + Math.abs(this.scale.y))/2);
}

Transform.prototype.reverse_xfrm = function(pt)
{
	var x = (pt.x - this.offset.x) / this.scale.x;
	var y = (pt.y - this.offset.y) / this.scale.y;
	return {x:x, y:y};
}

Transform.prototype.CalcMappingTransform = function(srcBounds, dstBounds, zoomLevel = undefined)
{
	// srcBounds,dstBounds: {min:{x,y}, max:{x, y}}
	// transform: {scale, offset:{x, y}
	// Use: 
	//   xDst = xSrc * transform.scale + transform.offset.x;
	var dstSize = {x:(dstBounds.max.x - dstBounds.min.x), y:(dstBounds.max.y - dstBounds.min.y) };
	var srcSize = {x:(srcBounds.max.x - srcBounds.min.x), y:(srcBounds.max.y - srcBounds.min.y)};
	
	// 2017.11.20: Added tests for zero source size
	if (MathUtil.EqualWithinTolerance(srcSize.x, 0, NORMAL_TOLERANCE))
		srcSize.x = dstSize.x;
		
	if (MathUtil.EqualWithinTolerance(srcSize.y, 0, NORMAL_TOLERANCE))
		srcSize.y = dstSize.y;
		
	var scaleX = dstSize.x / srcSize.x;
	var scaleY = dstSize.y / srcSize.y;
	
	// Use Math.abs() to allow for inverted axis (that is, flipping the vertical axis)
	var scale = (Math.abs(scaleX) < Math.abs(scaleY)) ? Math.abs(scaleX) : Math.abs(scaleY);
	
	// 2019.11.23: Optionally specify zoom level
	if (zoomLevel != undefined && typeof(zoomLevel) == "number")
		scale = zoomLevel;
		
	var sx = scale * Math.sign(scaleX);
	var sy = scale * Math.sign(scaleY);
	
	// Compute offsets that center scaled srcBounds within dstBounds
	var offsetX = (dstSize.x - srcSize.x * sx)/2 - sx * srcBounds.min.x + dstBounds.min.x;
	var offsetY = (dstSize.y - srcSize.y * sy)/2 - sy * srcBounds.min.y + dstBounds.min.y;
	
	this.scale = {x:sx, y:sy};
	this.offset = {x:offsetX, y:offsetY};
}

Transform.prototype.CalcTransformTo = function(endTransform, r)
{
	// Calculate in intermediate transform matrix between this matrix and the
	// endTransform matrix. 0 <= r <= 1.0
	//
	var a = this;
	var b = endTransform;
	var tx = new Transform();
	
	tx.scale.x  = a.scale.x  + r * (b.scale.x  - a.scale.x);
	tx.scale.y  = a.scale.y  + r * (b.scale.y  - a.scale.y);
	tx.offset.x = a.offset.x + r * (b.offset.x - a.offset.x);
	tx.offset.y = a.offset.y + r * (b.offset.y - a.offset.y);
	
	return tx;
}

Transform.prototype.AdjustScaleAroundBy = function(aroundPt, byPercent, scaleLimit)
{
	var scaleChanged = false;
	
	var newScaleX = this.scale.x + this.scale.x * byPercent;
	var newScaleY = this.scale.y + this.scale.y * byPercent;

	if (scaleLimit == undefined || (Math.abs(newScaleX) > scaleLimit && Math.abs(newScaleY) > scaleLimit))
	{
		var prevOffsetDelta = {x:(this.offset.x - aroundPt.x), y:(this.offset.y - aroundPt.y)};
		var prevScale = Object.assign({}, this.scale);
		this.scale.x = newScaleX;
		this.scale.y = newScaleY;
		
		if (scaleLimit != undefined)
		{
			if (Math.abs(this.scale.x) < scaleLimit)
				this.scale.x = scaleLimit * Math.abs(this.scale.x);

			if (Math.abs(this.scale.y) < scaleLimit)
				this.scale.y = scaleLimit * Math.sign(this.scale.y);
		}
		
		var newOffSetDeltaX = prevOffsetDelta.x * this.scale.x/prevScale.x;
		var newOffSetDeltaY = prevOffsetDelta.y * this.scale.y/prevScale.y;
	
		this.offset.x = aroundPt.x + newOffSetDeltaX;
		this.offset.y = aroundPt.y + newOffSetDeltaY;
		scaleChanged = true;
	}
	
	return scaleChanged;
}

Transform.prototype.Multiply = function(aTransform)
{
	var mx = this.Clone();
	
	mx.offset.x = aTransform.scale.x * mx.offset.x + aTransform.offset.x;
	mx.offset.y = aTransform.scale.y * mx.offset.y + aTransform.offset.y;

	mx.scale.x *= aTransform.scale.x;
	mx.scale.y *= aTransform.scale.y;
	
	return mx;
}


//-------------------------------------------------------------------------------------
//	MathUtil (API)
//
//
//-------------------------------------------------------------------------------------
var MathUtil = (function() {
	/*-----------------------------------------------*
	 * Utility Functions
	 *
	 * DistanceSquaredBetween
	 * DistanceBetween
	 * CalcAngleDiff
	 * CalcPointBetween
	 * CalcUnitVector
	 * CalcAngle
	 * xx CalcDistancePointToLin
	 * RectIntersectionTest
	 * EqualWithinTolerance
	 * r2d
	 * 
	 *-----------------------------------------------*/
	
	var DistanceSquaredBetween = function(posA, posB)
	{
		return (posA.x - posB.x) * (posA.x - posB.x) + (posA.y - posB.y) * (posA.y - posB.y);
	}

	var DistanceBetween = function(posA, posB)
	{
		return Math.sqrt(DistanceSquaredBetween(posA, posB));
	}

	/*-----------------------------------------------*
	 * Calculate Angle Difference: 
	 * Calculate the difference between two angles
	 * (in radians), and keep the result between
	 * zero and 2Pi
	 *-----------------------------------------------*/
	var CalcAngleDiff = function(angleA, angleB)
	{
		var angleDiff;
	
		angleDiff = angleA - angleB;
	
		if (angleDiff > Math.PI)
			angleDiff -= 2 * Math.PI;
		else if (angleDiff < -Math.PI)
			angleDiff += 2 * Math.PI;
	
		return angleDiff;
	}

	/*-----------------------------------------------*
	 * Calculate Point Between
	 * Calculate a point, ptC, between two points, 
	 * ptA and B, using ratio where 
	 * ptC = ptA when ratio = 0.0 and 
	 * ptC = ptB when ratio = 1.0
	 *-----------------------------------------------*/
	var CalcPointBetween = function(ptA, ptB, ratio)
	{
		var x = ptA.x + (ptB.x - ptA.x) * ratio;
		var y = ptA.y + (ptB.y - ptA.y) * ratio;
	
		return {x:x, y:y};
	}

	/*-----------------------------------------------*
	 * Radians to Degrees (for logging)
	 *-----------------------------------------------*/
	var r2d = function(r)
	{
		return Math.round(r * 180 / Math.PI);
	}

	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var CalcUnitVector = function(pointA, pointB)
	{
		var unitV;
		var len = Math.sqrt((pointB.x - pointA.x) * (pointB.x - pointA.x) + (pointB.y - pointA.y) * (pointB.y - pointA.y));
	
	
		if (len > 0)
			unitV = {x:(pointB.x - pointA.x)/len, y:(pointB.y - pointA.y)/len};

		//console.log(JSON.stringify(pointA) + "  " + JSON.stringify(pointB) + " len:" + len + " unitV:" + JSON.stringify(unitV));
	
		return unitV;
	}

	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var CalcAngle = function(fromPt, toPt)
	{
		var dx = toPt.x - fromPt.x;
		var dy = toPt.y - fromPt.y;
	
		var rad = Math.atan2(dy, dx);
	
		//if (rad < 0)
		//	rad = 2 * Math.PI + rad;
		
		return rad;
	}
	
	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var CalcVertexAngle = function(ptA, ptB, ptC)
	{
		return CalcAngleDiff(CalcAngle(ptA, ptB), CalcAngle(ptB, ptC));
	}
	
	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var CalcAngleBetweenLines = function(lnA, lnB)
	{
		return CalcAngleDiff(CalcAngle(lnA.ptA, lnA.ptB), CalcAngle(lnB.ptA, lnB.ptB));
	}
	
	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var IsAngle180 = function(ptA, ptB, ptC)
	{
		// Angle is 180 degrees if slopes are negative of
		// each other, i.e., 
		// dyBA/dxBA = -dyCB/dxCB 
		// dyBA * dxCB = -dyCB * dxBA
		// dyBA * dxCB + dyCB * dxBA = 0
		var dyBA = ptB.y - ptA.y;
		var dxBA = ptB.x - ptA.x;
		var dyCB = ptC.y - ptB.y;
		var dxCB = ptC.x - ptB.x;
		
		console.log("IsAngle180: ptA:" + JSON.stringify(ptA)+", ptB:" + JSON.stringify(ptB)+", ptC:" + JSON.stringify(ptC));
		console.log("IsAngle180: dyBA:"+dyBA+", dxBA:"+dxBA+", dyCB:"+dyCB+", dxCB:"+dxCB+", dyBA*dxCB + dyCB*dxBA:"+dyBA*dxCB + dyCB*dxBA); 
		 
		return EqualWithinTolerance(dyBA*dxCB + dyCB*dxBA, 0, ANGLE_TOLERANCE);
	}

	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var CalcIntersectionOfTwoLines = function(ptS, unitVectorS, ptT, unitVectorT)
	{
		var intersection = undefined;
	
		if (unitVectorS != undefined && unitVectorT != undefined)
		{
			//console.log(JSON.stringify(ptS) + " " + JSON.stringify(unitVectorS) +" "+JSON.stringify(ptT)+" "+JSON.stringify(unitVectorT));
			var den = unitVectorS.y * unitVectorT.x - unitVectorS.x * unitVectorT.y;
			var num = (ptS.x - ptT.x) * unitVectorT.y - (ptS.y - ptT.y) * unitVectorT.x;

			var dot = unitVectorS.x * unitVectorT.x + unitVectorS.y * unitVectorT.y;
	
			// The dot product of the unit vectors give the cosine of the angle between the 
			// vectors. If this is 1.0, then the lines are parallel and pointing in the same direction
			// If this is -1.0, then the are also parallel, but pointing in the opposite direction
			if (MathUtil.EqualWithinTolerance(dot, 1.0, NORMAL_TOLERANCE))
			{
				//intersection = {x:ptS.x + offsetDistance * unitVectorS.x, y:ptS.y + offsetDistance * unitVectorS.y};
			}
			else if (MathUtil.EqualWithinTolerance(dot, -1.0, NORMAL_TOLERANCE))
			{
				// Lines point in opposite direction. Return undefined
			}
			else
			{
				var v = num/den;
				intersection = {x:ptS.x + v * unitVectorS.x, y:ptS.y + v * unitVectorS.y};
				//console.log(JSON.stringify(intersection));
			}
		}
	
		return intersection;
	}

	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var CalcParallelLineOffset = function(ptP, ptOrigin, vectorLine, vectorOffset)
	{
		// A parallel line system is described with (ptOrigin, vectorLine, vectorOffset) where a given
		// parallel line can be then be identified as (point, vector):(ptOrigin + c * vectorOffset, vectorLine)
		// (Note that vectorOffset could simply be an orthogonal vector to vectorLine, but that is
		// not a requirement. The only requirement is that vectorLine and vectorOffset are not parallel.)
		//
		// This routine calculates the value c such that ptP is on the line (ptOrigin + c * vectorOffset, vectorLine)
		// 
		// Parameters:
		//   ptP: {x, y}
		//   ptOrigin: {x, y}
		//   vectorLine: {x, y}
		//   vectorOffset: {x, y}
		// Returns 
		//   undefined, if vectorLine and vectorOffset are parallel, otherwise
		//   float, c, as described above
		//
		var c = undefined;
		var vectorT = {x:(ptP.x - ptOrigin.x), y:(ptP.y - ptOrigin.y)};
		var num = vectorT.y      * vectorLine.x - vectorT.x      * vectorLine.y;
		var den = vectorOffset.y * vectorLine.x - vectorOffset.x * vectorLine.y;
		
		//if (!MathUtil.EqualWithinTolerance(den, 0, NORMAL_TOLERANCE))
		if (Math.abs(den) > 0.01)
			c = num / den;
		
		return c;
	}

	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var CalcLineSegmentIntersection = function(ptA, ptB, ptLine, vectorLine)
	{
		// Returns 
		//   undefined, if the line segment (A->B) is parallel to vectorLine, or
		//   float, c, where 0.0 is ptA, 1.0 is ptB
		//   The intersection point is ptA + c * (ptB - ptA)
		//
		var c = undefined;
		var vectorAB = {x:(ptA.x - ptB.x),    y:(ptA.y - ptB.y)};
		var vectorLA = {x:(ptA.x - ptLine.x), y:(ptA.y - ptLine.y)};
		var num = vectorLA.y * vectorLine.x - vectorLA.x * vectorLine.y;
		var den = vectorAB.y * vectorLine.x - vectorAB.x * vectorLine.y;
		
		if (!MathUtil.EqualWithinTolerance(den, 0, NORMAL_TOLERANCE))
			c = num / den;
		
		return c;
	}
	
	var CalcLineIntersectionWithAngles = function(ptA, angleA, ptB, angleB)
	{
		var pt = undefined;
		var vecA = {x:Math.cos(angleA), y:Math.sin(angleA)};
		var vecB = {x:Math.cos(angleB), y:Math.sin(angleB)};
		
		var c = CalcLineSegmentIntersection(ptA, {x:(ptA.x + vecA.x), y:(ptA.y + vecA.y)}, ptB, vecB);
		
		if (c != undefined)
			pt = {x:(ptA.x + c * vecA.x), y:(ptA.y + c * vecA.y)};

		return pt;		
	}
	
	var CalcLineSegmentIntersectionxx = function(ptA, ptB, ptLineA, ptLineB)
	{
		// Returns 
		//   undefined, if the line segment (A->B) is parallel to lineA->lineB, or
		//   float, c, where 0.0 is ptA, 1.0 is ptB
		//   The intersection point is ptA + c * (ptB - ptA)
		//
		var c = undefined;
		var vectorLine = {x:ptLineB.x - ptLineA.x, y:ptLineB.y - ptLineA.y};
		var vectorAB = {x:(ptA.x - ptB.x),    y:(ptA.y - ptB.y)};
		var vectorLA = {x:(ptA.x - ptLineA.x), y:(ptA.y - ptLineA.y)};
		var num = vectorLA.y * vectorLine.x - vectorLA.x * vectorLine.y;
		var den = vectorAB.y * vectorLine.x - vectorAB.x * vectorLine.y;
		
		if (!MathUtil.EqualWithinTolerance(den, 0, NORMAL_TOLERANCE))
			c = num / den;
		
		return c;
	}

	var CalcSegmentIntersection = function(ptA, ptB, ptC, ptD, alwaysReturnResults = false)
	{
		// q == ptA, s = ptB - ptA
		// p == ptC, r = ptD - ptC
		// t = (q − p) × s / (r × s)
		// u = (q − p) × r / (r × s)
		//
		// Returns 
		//   undefined, if the line segment (A->B) is parallel to lineA->lineB, or
		//   float, c, where 0.0 is ptA, 1.0 is ptB
		//   The intersection point is ptA + c * (ptB - ptA)
		//
		var c = undefined
		
		var s  = {x:(ptB.x - ptA.x),    y:(ptB.y - ptA.y)};
		var r  = {x:(ptD.x - ptC.x),    y:(ptD.y - ptC.y)};
		var qp = {x:(ptA.x - ptC.x),    y:(ptA.y - ptC.y)};
		var qt = {x:(ptA.x - ptD.x),    y:(ptA.y - ptD.y)};
		var num1 = qp.y * s.x - qp.x * s.y;
		var num2 = qp.y * r.x - qp.x * r.y;
		var num3 = qt.y * s.x - qt.x * s.y;
		var den  = r.y * s.x - r.x * s.y;
		var ptIntersection = undefined;
		
		
		var segmentsParallel = MathUtil.EqualWithinTolerance(den, 0, NORMAL_TOLERANCE);
		var coincidentSegments = false; // 2017.11.13: Added
		
		if (!segmentsParallel || alwaysReturnResults)
		{
			var cCD = undefined;
			var cAB = undefined;
			
			if (!segmentsParallel)
			{
				cCD = num1 / den;
				cAB = num2 / den;
			
				// Clean-up the values (if it's near 0.0 or 1.0, then make it 0.0 or 1.0)
				if (MathUtil.EqualWithinTolerance(cAB, 0.0, NORMAL_TOLERANCE))
					cAB = 0.0;
				else if (MathUtil.EqualWithinTolerance(cAB, 1.0, NORMAL_TOLERANCE))
					cAB = 1.0;

				if (MathUtil.EqualWithinTolerance(cCD, 0.0, NORMAL_TOLERANCE))
					cCD = 0.0;
				else if (MathUtil.EqualWithinTolerance(cCD, 1.0, NORMAL_TOLERANCE))
					cCD = 1.0;
			
				// Set endpointXY to true if the intersection is at point X or point Y
				var endpointAB = MathUtil.EqualWithinTolerance(cAB, 0.0, NORMAL_TOLERANCE) || MathUtil.EqualWithinTolerance(cAB, 1.0, NORMAL_TOLERANCE);
				var endpointCD = MathUtil.EqualWithinTolerance(cCD, 0.0, NORMAL_TOLERANCE) || MathUtil.EqualWithinTolerance(cCD, 1.0, NORMAL_TOLERANCE);
				
				// Set withinXY to true if the intersection is between point X and point Y
				var withinAB = (cAB > 0 && cAB < 1.0);
				var withinCD = (cCD > 0 && cCD < 1.0);

				// Attempt to reduce rounding errors by computing the point here and passing out
				// https://en.wikipedia.org/wiki/Line%E2%80%93line_intersection
				// 1:ptA, 2:ptB, 3:ptC, 4:ptD
				var denB = (ptA.x - ptB.x) * (ptC.y - ptD.y) - (ptA.y - ptB.y) * (ptC.x - ptD.x);
				var numX = (ptA.x * ptB.y - ptA.y * ptB.x)*(ptC.x - ptD.x) - (ptA.x - ptB.x)*(ptC.x * ptD.y - ptC.y * ptD.x);
				var numY = (ptA.x * ptB.y - ptA.y * ptB.x)*(ptC.y - ptD.y) - (ptA.y - ptB.y)*(ptC.x * ptD.y - ptC.y * ptD.x);
				ptIntersection = {x:numX/denB, y:numY/denB};

			}
			else // 2017.11.13: Test for coincident lines
			{
				// 
				var onLineTestValue = s.y * ptC.x - s.x * ptC.y + ptB.x * ptA.y - ptB.y * ptA.x;
				if (MathUtil.EqualWithinTolerance(onLineTestValue, 0.0, NORMAL_TOLERANCE))
				{
					// Lines are parallel and go through the same points.
					// Do line segments overlap?
					if (0 /* line segments overlap */) 
					{
					}
				}

			}

			if (endpointAB && endpointCD && !alwaysReturnResults)
			{
				// Do nothing. 
			}
			else if ((endpointAB && withinCD) || (endpointCD && withinAB) || (withinAB && withinCD) || alwaysReturnResults)
 			{
 				c = {c1:cAB, c2:cCD, segmentsParallel:segmentsParallel, ptCinsideAB:(num1 < 0), ptDinsideAB:(num3 < 0), ptIntersection:ptIntersection};
 			}
		}
		
		return c;
	}
	
	var CalcPointToLineDistance = function(point, linePtA, linePtB)
	{
		var distance = undefined;
		
		var vecAB = {x:(linePtB.x - linePtA.x), y:(linePtB.y - linePtA.y)};
		
		var n = vecAB.y * point.x - vecAB.x * point.y + linePtB.x * linePtA.y - linePtB.y * linePtA.x;
		var d = Math.sqrt(vecAB.x * vecAB.x + vecAB.y * vecAB.y);
		
		if (!MathUtil.EqualWithinTolerance(d, 0.0, NORMAL_TOLERANCE))
		{
			distance = Math.abs(n/d);
		}
		return distance;
	}

	var IsPointOnLine = function(point, linePtA, linePtB)
	{
		var onLine = false;
		
		var vecAB = {x:(linePtB.x - linePtA.x), y:(linePtB.y - linePtA.y)};
		
		var n = vecAB.y * point.x - vecAB.x * point.y + linePtB.x * linePtA.y - linePtB.y * linePtA.x;
		
		onLine = MathUtil.EqualWithinTolerance(n, 0.0, NORMAL_TOLERANCE);

		return onLine;
	}
	

	var CalcNearestPointOnLine = function(point, linePtA, linePtB)
	{
		var ptOnLine = undefined;
		
		// Vector from A to B
		var vecAB = {x:(linePtB.x - linePtA.x), y:(linePtB.y - linePtA.y)};
		// Normal vector
		var vecABnormal = {x:vecAB.y, y:-vecAB.x};
		// Point such that line (point -> pointB) is perpendicular to (linePtA -> linePtB)
		var pointB = {x:(point.x + vecABnormal.x), y:(point.y + vecABnormal.y)};
		
		var cInfo = CalcSegmentIntersection(point, pointB, linePtA, linePtB, true);
		
		if (!cInfo.segmentsParallel)
		{
			var c = cInfo.c1;
			
			// 2019.03.11: Use point now available
			//ptOnLine = {x: point.x + c * vecABnormal.x, y: point.y + c * vecABnormal.y };
			ptOnLine = cInfo.ptIntersection;
			// Also return a value that indicates where on the line the intersection occurs.
			// This value is between zero and one if the intersection occurs between 
			// linePtA and linePtB
			ptOnLine.cLineAB = cInfo.c2;
			
		}
		
		return ptOnLine;
	}
	
	var AreVectorsParallel = function(vectorA, vectorB)
	{
		var den = vectorA.y * vectorB.x - vectorA.x * vectorB.y;
		
		var vectorsParallel = MathUtil.EqualWithinTolerance(den, 0, NORMAL_TOLERANCE);
		
		return vectorsParallel;
	}
	

	/*-----------------------------------------------*
	 * Calculate Tangent Arc Parameters
	 * Given
	 *   Points ptA, ptB, ptC
	 *   Distance distance
	 * Find Arc info
	 *   Point ptCenter
	 *   Tangent Points on lines AB and BC
	 *   Radius r
	 *   Angles angleStart, angleEnd
	 * If distance < len(ptA,ptB)/2 or len(ptB,ptC)/2
	 *   Then distance = min of the half lengths
	 *-----------------------------------------------*/
	var CalcTangentArcParams = function(ptA, ptB, ptC, distance)
	{
		var arcParams = undefined;
		
		// If the vertex, that is, the angle between line AB and line BC, is either zero or 180 degrees, then return undefined
		var angleStart = MathUtil.CalcAngle(ptA, ptB);
		var angleEnd   = MathUtil.CalcAngle(ptB, ptC);
		var vertexAngle = CalcAngleDiff(angleStart, angleEnd);
		
		if (!EqualWithinTolerance(vertexAngle, 0, ANGLE_TOLERANCE) &&
		    !EqualWithinTolerance(vertexAngle, -Math.PI, ANGLE_TOLERANCE) &&
		    !EqualWithinTolerance(vertexAngle, Math.PI, ANGLE_TOLERANCE))
		{
			var lenAB = DistanceBetween(ptA, ptB);
			var lenBC = DistanceBetween(ptB, ptC);
			var unitAB = CalcUnitVector(ptA, ptB);
			var unitBC = CalcUnitVector(ptB, ptC);
			
			// CalcUnitVector returns undefined for zero length segments
			if (unitAB != undefined && unitBC != undefined)
			{
				// Limit the distance
				var d = distance;
		
				if (d > lenAB/2)
					d = lenAB/2;
			
				if (d > lenBC/2)
					d = lenBC/2;
			
				// Point ptD is on line AB, d units away from B toward A
				// Point ptE is on line BC, d units away from B toward C
				var ptD = {x:ptB.x - d * unitAB.x, y:ptB.y - d * unitAB.y};
				var ptE = {x:ptB.x + d * unitBC.x, y:ptB.y + d * unitBC.y};
			
				var ccw = false;
		
				if (vertexAngle < 0)
				{
					angleStart += -Math.PI/2;
					angleEnd   += -Math.PI/2;
				}
				else
				{
					angleStart += Math.PI/2;
					angleEnd   += Math.PI/2;
					ccw = true;
				}
		
				var ptCenter = CalcIntersectionOfTwoLines(ptD, {x:unitAB.y, y:-unitAB.x}, ptE, {x:unitBC.y, y:-unitBC.x});
		
				if (ptCenter != undefined)
				{
					var r = DistanceBetween(ptD, ptCenter);
		
					arcParams = { center:ptCenter, ptTangentAB:ptD, ptTangentBC:ptE, radius:r, distance:d, startAngle:angleStart, endAngle:angleEnd, ccw:ccw };
				}
			}
		}
		return arcParams;
	}
	
	/*-----------------------------------------------*
	 * Calculate Quad Bezier Parameters
	 * Given
	 *   Points ptA, ptB, ptC
	 *   Distance distance
	 * Find Quad Bezier info
	 *   Tangent Points on lines AB and BC
	 * If distance < len(ptA,ptB)/2 or len(ptB,ptC)/2
	 *   Then distance = min of the half lengths
	 *-----------------------------------------------*/
	var CalcQuadBezierParams = function(ptA, ptB, ptC, distance)
	{
		var quadParams = undefined;
		
		// If the vertex, that is, the angle between line AB and line BC, is either zero or 180 degrees, then return undefined
		var angleStart = MathUtil.CalcAngle(ptA, ptB);
		var angleEnd   = MathUtil.CalcAngle(ptB, ptC);
		var vertexAngle = CalcAngleDiff(angleStart, angleEnd);
		
		if (!EqualWithinTolerance(vertexAngle, 0, ANGLE_TOLERANCE) &&
		    !EqualWithinTolerance(vertexAngle, -Math.PI, ANGLE_TOLERANCE) &&
		    !EqualWithinTolerance(vertexAngle, Math.PI, ANGLE_TOLERANCE))
		{
			var lenAB = DistanceBetween(ptA, ptB);
			var lenBC = DistanceBetween(ptB, ptC);
			var unitAB = CalcUnitVector(ptA, ptB);
			var unitBC = CalcUnitVector(ptB, ptC);
			
			// CalcUnitVector returns undefined for zero length segments
			if (unitAB != undefined && unitBC != undefined)
			{
				// Limit the distance
				var dAB = distance;
				var dBC = distance;
		
				if (dAB > lenAB/2)
					dAB = lenAB/2;
			
				if (dBC > lenBC/2)
					dBC = lenBC/2;
					
				if (1 /* symmetric */)
				{
					if (dAB > dBC)
						dAB = dBC;
					else if (dBC > dAB)
						dBC = dAB
				}
			
				// Point ptD is on line AB, d units away from B toward A
				// Point ptE is on line BC, d units away from B toward C
				var ptD = {x:ptB.x - dAB * unitAB.x, y:ptB.y - dAB * unitAB.y};
				var ptE = {x:ptB.x + dBC * unitBC.x, y:ptB.y + dBC * unitBC.y};
					
				quadParams = { ptTangentAB:ptD, ptTangentBC:ptE /*, distance:d */ };
			}
		}
		return quadParams;
	}
	
	/*-----------------------------------------------*
	 * Rect Intersection Test
	 *-----------------------------------------------*/
	var RectIntersectionTest = function(r1, r2)
	{
		var result = false;
	
		if (r1.x + r1.width < r2.x)
		{ }
		else if (r2.x + r2.width < r1.x)
		{ }
		else if (r1.y + r1.height < r2.y)
		{ }
		else if (r2.y + r2.height < r1.y)
		{ }
		else
		{
			result = true;
		}
	
		return result;
	}

	var ClipSegmentAgainstPolygon_orig = function(pointA, pointB, clipPolygon)
	{
		// Clip the segment, defined by pointA -> pointB, against the (convex) polygon, given as
		// a list of points in clipPolygon.
		// Return:
		//   undefined: the segment lies completely within the clipPolygon
		//   {ignoreSegment:true}: the segment lies complete outside of the clipPolygon
		//   {ptA:{x, y}, ptB:{x, y}}: a new segment that lies within clipPolygon
		//
		
		var ptPair = undefined;
		var done = false;
		
		var ptAinside = true;
		var ptBinside = true;
		
		// For edge in the polygon...
		for (var i = 0; i < clipPolygon.length && !done; i++)
		{
			var clipPtA = clipPolygon[i];
			var clipPtB = clipPolygon[(i + 1) % clipPolygon.length];
		
			// Determine where the line segment lies in relation to the polygon edge
			var cPair = MathUtil.CalcSegmentIntersection(clipPtA, clipPtB, pointA, pointB, true /* always return results */);
		
			if (cPair != undefined)
			{
				if (!cPair.ptCinsideAB)
					ptAinside = false;
					
				if (!cPair.ptDinsideAB)
					ptBinside = false;
					
				if (cPair.ptCinsideAB && cPair.ptDinsideAB)
				{
					// do nothing
				}
				else if (!cPair.ptCinsideAB && !cPair.ptDinsideAB)
				{
					ptPair = {};
					ptPair.ignoreSegment = true;
					done = true;
				}
				else if (cPair.c1 >= 0 && cPair.c1 <= 1.0 && cPair.c2 >= 0 && cPair.c2 <= 1.0)
				{
					var c = cPair.c2;
					var p = {x: pointA.x + c * (pointB.x - pointA.x), y: pointA.y + c * (pointB.y - pointA.y) };
					
					ptPair = {};
					if (cPair.ptCinsideAB)
					{
						ptPair.ptA = pointA;
						ptPair.ptB = p;
					}
					else
					{
						ptPair.ptA = p;
						ptPair.ptB = pointB;
					}
				}
			}
			
			if (!ptAinside && !ptBinside)
			{
				if (ptPair == undefined)
					ptPair = {};
				ptPair.ignoreSegment = true; // NEED TO TEST FOR INTERSECTION
			}
		}
		
		return ptPair;
	}

	var PolygonIntersectionResult = Object.freeze({
		NONE		: 0,
		PARTIAL		: 1,
		CONTAINED	: 2
		});

	var DoPolygonsIntersect = function(testPolygon, clipPolygon)
	{
		// Determine if the test polygon intersects the clipPolygon
		//
		var result = PolygonIntersectionResult.NONE;
		
		var edgesInside = 0;
		var edgesOutside = 0;
		var edgesBoth = 0;
		
		for (var i = 0; i < testPolygon.length; i++)
		{
			var ptA = testPolygon[i];
			var ptB = testPolygon[(i + 1) % testPolygon.length];
			
			var clipResult = ClipSegmentAgainstPolygon(ptA, ptB, clipPolygon);
			
			if (clipResult == undefined)
				edgesInside++;
			else if (clipResult.ignoreSegment)
				edgesOutside++;
			else
				edgesBoth++;
		}
		
		if (edgesBoth > 0)
			result = PolygonIntersectionResult.PARTIAL;
		else if (edgesInside == 0 && edgesOutside > 0)
			result = PolygonIntersectionResult.NONE;
		else if (edgesInside > 0 && edgesOutside == 0)
			result = PolygonIntersectionResult.CONTAINED;
		else if (edgesInside > 0 && edgesOutside > 0)
			result = PolygonIntersectionResult.PARTIAL;
		else
			console.log("DoPolygonsIntersect: log error: edgesInside:" + edgesInside + ", edgesOutside:" + edgesOutside + ", edgesBoth:" + edgesBoth + ", edge count:" + testPolygon.length);
			
			
		return result;
	}

	var ClipSegmentAgainstPolygon = function(pointA, pointB, clipPolygon)
	{
		// Clip the segment, defined by pointA -> pointB, against the (convex) polygon, given as
		// a list of points in clipPolygon.
		// Return:
		//   undefined: the segment lies completely within the clipPolygon
		//   {ignoreSegment:true}: the segment lies complete outside of the clipPolygon
		//   {ptA:{x, y}, ptB:{x, y}}: a new segment that lies within clipPolygon
		//
		
		var ptPair = undefined;
		var ptAinside = true;
		var ptBinside = true;
		var ptList = [];
		
		var intersectionList = [];

		// Build a list of intersections between the line segment and each edge in the polygon.
		// Also do a simple test to determine if the endpoints are in the polygon
		for (var i = 0; i < clipPolygon.length; i++)
		{
			var clipPtA = clipPolygon[i];
			var clipPtB = clipPolygon[(i + 1) % clipPolygon.length];
		
			// Determine where the line segment lies in relation to the polygon edge
			var cPair = MathUtil.CalcSegmentIntersection(clipPtA, clipPtB, pointA, pointB, true /* always return results */);
		
			if (cPair != undefined)
			{
				if (cPair.c1 >= 0 && cPair.c1 <= 1.0 && cPair.c2 >= 0 && cPair.c2 <= 1.0)
					intersectionList.push(cPair.c2);
				
				// Simple test to determine if a point is outside a CONVEX polygon.
				// A different test is needed for concave or complex polygons.
				if (!cPair.ptCinsideAB)
					ptAinside = false;
					
				if (!cPair.ptDinsideAB)
					ptBinside = false;
			}
		}
		
		// Add the endpoints that are inside the polygon
		if (ptAinside)
			intersectionList.push(0.0);
			
		if (ptBinside)
			intersectionList.push(1.0);
			
		// Sort the intersection list
		intersectionList.sort(function(a, b) {return a - b});
		
		// Remove duplicate items from the list. This can happen if a line
		// intersects the endpoints of more than one line at the same location, such
		// as the corner of a frame.
		for (var k = intersectionList.length - 1; k > 0; k--)
			if (MathUtil.EqualWithinTolerance(intersectionList[k], intersectionList[k - 1], NORMAL_TOLERANCE))
				intersectionList.splice(k, 1);
		
		// Create a list of points, each pair represents a start/end of a line segment
		for (var i = 0; i < intersectionList.length; i++)
		{
			var c = intersectionList[i];
			var p;
			
			if (MathUtil.EqualWithinTolerance(c, 0.0, NORMAL_TOLERANCE))
				p = pointA;
			else if (MathUtil.EqualWithinTolerance(c, 1.0, NORMAL_TOLERANCE))
				p = pointB;
			else
				p = {x: pointA.x + c * (pointB.x - pointA.x), y: pointA.y + c * (pointB.y - pointA.y) };
			
			ptList.push(p);			
		}
		
		//if ((ptList.length % 2 != 0) || (intersectionList.length % 2 != 0))
		//{
		//	console.log("ClipSegmentAgainstPolygon: Unusual list length");
		//	console.log("c-values: " + JSON.stringify(intersectionList));
		//	console.log("points: " + JSON.stringify(ptList));
		//}
		
		// If the point list is empty, then return 'ignore segment'
		if (ptList.length == 0)
		{
			ptPair = {};
			ptPair.ignoreSegment = true;
		}
		// If the point list has one item, that means the segment probably 
		// intersected at the vertex of the polygon
		// NOTE: This will need to be re-evaluated for concave or complex polygons
		else if (ptList.length == 1)
		{
			ptPair = {};
			ptPair.ignoreSegment = true;
		}
		// If the point list has only the beginning and end points, then return indicator
		// that segment lies within polygon
		else if (ptAinside & ptBinside && ptList.length == 2)
		{
		}
		else
		{
			ptPair = {};
			ptPair.ptA = ptList[0];
			ptPair.ptB = ptList[1];
		}
			
		return ptPair;
	}

	var ScaleSizeIntoContainerSize = function(originalSize, containerSize)
	{
		var scaleX = containerSize.x / originalSize.x;
		var scaleY = containerSize.y / originalSize.y;
		var scale = (scaleX < scaleY) ? scaleX : scaleY;
		var scaledSize = {x:(originalSize.x * scale), y:(originalSize.y * scale)};
		
		return scaledSize;
	}


	function RotatePointAroundOrigin(pt, angle)
	{
		var rad = angle * Math.PI / 180.0;
		var x = pt.x * Math.cos(rad) - pt.y * Math.sin(rad);
		var y = pt.x * Math.sin(rad) + pt.y * Math.cos(rad);	
		return {x:x, y:y};
	}

	function RotatePoint(pt, refPt, angleRadians)
	{
		var x = refPt.x + (pt.x - refPt.x) * Math.cos(angleRadians) - (pt.y - refPt.y) * Math.sin(angleRadians);
		var y = refPt.y + (pt.x - refPt.x) * Math.sin(angleRadians) + (pt.y - refPt.y) * Math.cos(angleRadians);	
		return {x:x, y:y};
	}

	var CalcRotatedFrameBounds = function(frameBounds, rotation)
	{
		var pts = [];
		
		pts.push({x:frameBounds.min.x, y:frameBounds.min.y});
		pts.push({x:frameBounds.max.x, y:frameBounds.min.y});
		pts.push({x:frameBounds.max.x, y:frameBounds.max.y});
		pts.push({x:frameBounds.min.x, y:frameBounds.max.y});
		
		for (var i = 0; i < 4; i++)
			pts[i] = MathUtil.RotatePointAroundOrigin(pts[i], rotation);
			
		var rotatedFrameBounds = { min: {x: pts[0].x, y: pts[0].y}, max: {x: pts[0].x, y:pts[0].y} };
		
		for (var i = 1; i < 4; i++)
		{
			var x = pts[i].x;
			var y = pts[i].y;
			
			if (rotatedFrameBounds.min.x > x)
				rotatedFrameBounds.min.x = x;
			if (rotatedFrameBounds.max.x < x)
				rotatedFrameBounds.max.x = x;
			if (rotatedFrameBounds.min.y > y)
				rotatedFrameBounds.min.y = y;
			if (rotatedFrameBounds.max.y < y)
				rotatedFrameBounds.max.y = y;
				
		}
		
		return rotatedFrameBounds;
	}

	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var EqualWithinTolerance = function(valA, valB, toleranceBase)
	{
		var diff = Math.abs(valA - valB);
	
		//var equal = (Math.floor(diff * toleranceBase) == 0);
		var equal = (diff < 1/toleranceBase);
	
		return equal
	}
	
	/*-----------------------------------------------*
	 *	Identity Matrix (3x3)
	 *-----------------------------------------------*/
	var IdentityMat = function()
	{
		return [[1,0,0],[0,1,0],[0,0,1]];
	}
	
	/*-----------------------------------------------*
	 *	Translate Matrix (3x3)
	 *-----------------------------------------------*/
	var TranslateMat = function(translate)
	{
		var m = IdentityMat();
		m[0][2] = translate.x;
		m[1][2] = translate.y;
		return m;
	}
	
	/*-----------------------------------------------*
	 *	Rotate Matrix (3x3)
	 *-----------------------------------------------*/
	var RotateMat = function(angleRadians)
	{
		var m = IdentityMat();
		m[0][0] = Math.cos(angleRadians);
		m[0][1] = Math.sin(angleRadians);
		m[1][1] = m[0][0];
		m[1][0] = -m[0][1];
		return m;
	}
	
	/*-----------------------------------------------*
	 *	Multiply Matrices (3x3)
	 *-----------------------------------------------*/
	var MultMat = function(a,b)
	{
		var m = IdentityMat();
		m[0][0] = a[0][0]*b[0][0] + a[0][1]*b[1][0] + a[0][2]*b[2][0];
		m[0][1] = a[0][0]*b[0][1] + a[0][1]*b[1][1] + a[0][2]*b[2][1];
		m[0][2] = a[0][0]*b[0][2] + a[0][1]*b[1][2] + a[0][2]*b[2][2];

		m[1][0] = a[1][0]*b[0][0] + a[1][1]*b[1][0] + a[1][2]*b[2][0];
		m[1][1] = a[1][0]*b[0][1] + a[1][1]*b[1][1] + a[1][2]*b[2][1];
		m[1][2] = a[1][0]*b[0][2] + a[1][1]*b[1][2] + a[1][2]*b[2][2];

		m[2][0] = a[2][0]*b[0][0] + a[2][1]*b[1][0] + a[2][2]*b[2][0];
		m[2][1] = a[2][0]*b[0][1] + a[2][1]*b[1][1] + a[2][2]*b[2][1];
		m[2][2] = a[2][0]*b[0][2] + a[2][1]*b[1][2] + a[2][2]*b[2][2];
		
		return m;
	}

	/*-----------------------------------------------*
	 *	Multiply Matrix List (3x3)
	 *-----------------------------------------------*/
	var MultMatList = function(mlist)
	{
		var m = IdentityMat();
		
		for (var i = 0; i < mlist.length; i++)
			m = MultMat(m, mlist[i]);
			
		return m;
		
	}
	var MultMatPt = function(m, pt)
	{
		return {x:(m[0][0]*pt.x + m[0][1]*pt.y + m[0][2]), y:(m[1][0]*pt.x + m[1][1]*pt.y + m[1][2])};
	}
	
	return {
		DistanceSquaredBetween:			DistanceSquaredBetween,
		DistanceBetween:				DistanceBetween,
		CalcAngleDiff:					CalcAngleDiff,
		CalcPointBetween:				CalcPointBetween,
		r2d:							r2d,
		CalcUnitVector:					CalcUnitVector,
		CalcAngle:						CalcAngle,
		CalcVertexAngle:				CalcVertexAngle,
		CalcAngleBetweenLines:			CalcAngleBetweenLines,
		IsAngle180:						IsAngle180,
		CalcTangentArcParams:			CalcTangentArcParams,
		CalcQuadBezierParams:			CalcQuadBezierParams,
		RectIntersectionTest:			RectIntersectionTest,
		EqualWithinTolerance:			EqualWithinTolerance,
		CalcParallelLineOffset:			CalcParallelLineOffset,
		CalcLineSegmentIntersection:	CalcLineSegmentIntersection,
		CalcSegmentIntersection:		CalcSegmentIntersection,
		CalcLineIntersectionWithAngles:	CalcLineIntersectionWithAngles,
		AreVectorsParallel:				AreVectorsParallel,
		CalcPointToLineDistance:		CalcPointToLineDistance,
		CalcNearestPointOnLine:			CalcNearestPointOnLine,
		IsPointOnLine:					IsPointOnLine,
		ClipSegmentAgainstPolygon:		ClipSegmentAgainstPolygon,
		DoPolygonsIntersect:			DoPolygonsIntersect,
		PolygonIntersectionResult:		PolygonIntersectionResult,
		ScaleSizeIntoContainerSize:		ScaleSizeIntoContainerSize,
		RotatePoint:					RotatePoint,
		RotatePointAroundOrigin:		RotatePointAroundOrigin,
		CalcRotatedFrameBounds:			CalcRotatedFrameBounds,
		TranslateMat:					TranslateMat,
		RotateMat:						RotateMat,
		MultMat:						MultMat,
		MultMatList:					MultMatList,
		MultMatPt:						MultMatPt
		
	};
}());

//-------------------------------------------------------------------------------------
//	Math3D
//
//	Definitions
//		pt3: {x:x, y:y, z:z}
//		vec3: {x:x, y:y, z:z}
//		mat3: m[3][3]
//		line: {pt:pt3, v:vec3}
//		plane: {pt:pt3, n:vec3}
//		polygon: p[ .. pt3 .. ]
//-------------------------------------------------------------------------------------
var Math3D = (function() {

	//-------------------------------------------------------------------------------------
	//	Mat3
	//-------------------------------------------------------------------------------------
	function Mat3()
	{
		return [[0, 0, 0], [0, 0, 0], [0, 0, 0]];
	}
	
	//-------------------------------------------------------------------------------------
	//	IdentityMat3
	//-------------------------------------------------------------------------------------
	function IdentityMat3()
	{
		let m = Mat3();
		m[0][0] = 1;
		m[1][1] = 1;
		m[2][2] = 1;
	
		return m;
	}

	//-------------------------------------------------------------------------------------
	//	RotationMat3
	//-------------------------------------------------------------------------------------
	function RotationMat3(angle, axis) /* "x", "y", or "z" */
	{

		let c = Math.cos(angle);
		let s = Math.sin(angle);
		let m = IdentityMat3();
	
		if (axis == "x")
		{
			m[1][1] =  c; m[1][2] = s;
			m[2][1] = -s; m[2][2] = c;
		}
		else if (axis == "y")
		{
			m[2][2] =  c; m[2][0] = s;
			m[0][2] = -s; m[0][0] = c;
		}
		else if (axis == "z")
		{
			m[0][0] =  c; m[0][1] = s;
			m[1][0] = -s; m[1][1] = c;
		}
	
		return m;
	}

	//-------------------------------------------------------------------------------------
	//	MultMat3Mat3
	//-------------------------------------------------------------------------------------
	function MultMat3Mat3(ma, mb)
	{
		let m = Math3D.Mat3();
	
		m[0][0] = ma[0][0] * mb[0][0] + ma[0][1] * mb[1][0] + ma[0][2] * mb[2][0];
		m[0][1] = ma[0][0] * mb[0][1] + ma[0][1] * mb[1][1] + ma[0][2] * mb[2][1];
		m[0][2] = ma[0][0] * mb[0][2] + ma[0][1] * mb[1][2] + ma[0][2] * mb[2][2];

		m[1][0] = ma[1][0] * mb[0][0] + ma[1][1] * mb[1][0] + ma[1][2] * mb[2][0];
		m[1][1] = ma[1][0] * mb[0][1] + ma[1][1] * mb[1][1] + ma[1][2] * mb[2][1];
		m[1][2] = ma[1][0] * mb[0][2] + ma[1][1] * mb[1][2] + ma[1][2] * mb[2][2];
	
		m[2][0] = ma[2][0] * mb[0][0] + ma[2][1] * mb[1][0] + ma[2][2] * mb[2][0];
		m[2][1] = ma[2][0] * mb[0][1] + ma[2][1] * mb[1][1] + ma[2][2] * mb[2][1];
		m[2][2] = ma[2][0] * mb[0][2] + ma[2][1] * mb[1][2] + ma[2][2] * mb[2][2];

		return m;
	}

	//-------------------------------------------------------------------------------------
	//	SubVec3Vec3
	//-------------------------------------------------------------------------------------
	function SubVec3Vec3(a, b)
	{
		return {x:a.x - b.x, y:a.y - b.y, z:a.z - b.z};
	}
	
	//-------------------------------------------------------------------------------------
	//	InterpolateVec3Vec3
	//-------------------------------------------------------------------------------------
	function InterpolateVec3Vec3(a, b, t)
	{
		return {x:a.x + t * (b.x - a.x), y:a.y + t * (b.y - a.y), z:a.z + t * (b.z - a.z)};
	}
	
	//-------------------------------------------------------------------------------------
	//	LenVec3
	//-------------------------------------------------------------------------------------
	function LenVec3(v)
	{
		let len = Math.sqrt(v.x * v.x + v.y * v.y + v.z * v.z);
		return len;
	}

	//-------------------------------------------------------------------------------------
	//	AddVec3ScaledVec3
	//-------------------------------------------------------------------------------------
	function AddVec3ScaledVec3(a, b, s = 1.0)
	{
		return {x:a.x + s * b.x, y:a.y + s * b.y, z:a.z + s * b.z};
	}

	//-------------------------------------------------------------------------------------
	//	MultMat3Vec3
	//-------------------------------------------------------------------------------------
	function MultMat3Vec3(m, v)
	{
		let u = {x:0, y:0, z:0};
	
		u.x = m[0][0] * v.x + m[0][1] * v.y + m[0][2] * v.z;
		u.y = m[1][0] * v.x + m[1][1] * v.y + m[1][2] * v.z;
		u.z = m[2][0] * v.x + m[2][1] * v.y + m[2][2] * v.z;
	
		return u;
	}

	//-------------------------------------------------------------------------------------
	//	UnitVec3
	//-------------------------------------------------------------------------------------
	function UnitVec3(v)
	{
		let len = Math.sqrt(v.x * v.x + v.y * v.y + v.z * v.z);
		var u = undefined;
	
		if (len > 0)
			u = {x: v.x/len, y:v.y/len, z:v.z/len};
		
		return u;
	}

	//-------------------------------------------------------------------------------------
	//	ToUnitVec3
	//-------------------------------------------------------------------------------------
	function ToUnitVec3(v)
	{
		let len = Math.sqrt(v.x * v.x + v.y * v.y + v.z * v.z);
	
		if (len > 0)
		{
			v.x /= len;
			v.y /= len;
			v.z /= len;
		}
		return v;
	}

	//-------------------------------------------------------------------------------------
	//	ScaleVec3
	//-------------------------------------------------------------------------------------
	function ScaleVec3(v, s)
	{
		return {x:s*v.x, y:s*v.y, z:s*v.z};
	}

	//-------------------------------------------------------------------------------------
	//	CrossProduct
	//-------------------------------------------------------------------------------------
	function CrossProduct(a, b)
	{
		let sx = a.y * b.z - a.z * b.y;
		let sy = a.z * b.x - a.x * b.z;
		let sz = a.x * b.y - a.y * b.x;
	
		return {x:sx, y:sy, z:sz};
	}

	//-------------------------------------------------------------------------------------
	//	DotProduct
	//-------------------------------------------------------------------------------------
	function DotProduct(a, b)
	{
		let dot = a.x * b.x + a.y * b.y + a.z * b.z;
	
		return dot;
	}


	//-------------------------------------------------------------------------------------
	//	OrthoPlaneUnitVectors
	//-------------------------------------------------------------------------------------
	var OrthoPlaneUnitVectors = function(planeNormal)
	{
		var orthoAB3s; // = {x:-unitAB.y, y:unitAB.x, z:0};
		var orthoAB3t; // = {x:0, y:0, z:1.0 /* unit length */};
	
		let ax = planeNormal.x;
		let ay = planeNormal.y;
		let az = planeNormal.z;
		let lenxy = Math.sqrt(ax * ax + ay * ay);
	
		// Orthogonal unit vector in XY plane (z is zero)
		var bx, by, bz;
		if (lenxy > 0.00001)
		{
			bx = -ay / lenxy;
			by =  ax / lenxy;
			bz =  0;
		}
		else
		{
			bx =  1;
			by =  0;
			bz =  0;
		}
	
		var orthoS = {x:bx, y:by, z:bz};
		var orthoT = Math3D.CrossProduct(planeNormal, orthoS);
		let len = Math.sqrt(orthoT.x * orthoT.x + orthoT.y * orthoT.y + orthoT.z * orthoT.z);
		orthoT.x /= len;
		orthoT.y /= len;
		orthoT.z /= len;
	
		return {s:orthoS, t:orthoT};
	}

	//-------------------------------------------------------------------------------------
	//	LinePlaneIntersection
	//-------------------------------------------------------------------------------------
	var LinePlaneIntersection = function(line, plane)
	{
		let v = SubVec3Vec3(plane.pt, line.pt);
		let dpNum = DotProduct(v, plane.n);
		let dpDen = DotProduct(line.v, plane.n);
		let d = dpNum / dpDen;
		
		let pt = AddVec3ScaledVec3(line.pt, line.v, d);
		
		return pt;
	}

	//-------------------------------------------------------------------------------------
	//	CalcOffsetVertex
	//-------------------------------------------------------------------------------------
	var CalcOffsetVertex = function(threePointList, offsetDistanceAB, offsetDistanceBC)
	{
		var offsetVtx = undefined;
		var A = threePointList[0];
		var B = threePointList[1];
		var C = threePointList[1];
		var D = threePointList[2];

		var unitAB = Math3D.UnitVec3(Math3D.SubVec3Vec3(A, B));
		var unitCD = Math3D.UnitVec3(Math3D.SubVec3Vec3(C, D));
	
		if (offsetDistanceCD == undefined)
			offsetDistanceCD = offsetDistanceAB;

		// MathUtil.CalcUnitVector returns undefined for vectors of zero length
		if (unitAB != undefined && unitCD != undefined)
		{
			var E = {x:(B.x + offsetDistanceAB * unitAB.y), y:(B.y - offsetDistanceAB * unitAB.x)};
			var F = {x:(D.x + offsetDistanceCD * unitCD.y), y:(D.y - offsetDistanceCD * unitCD.x)};

			var den = unitAB.y * unitCD.x - unitAB.x * unitCD.y;
			var num = (E.x - F.x) * unitCD.y - (E.y - F.y) * unitCD.x;

			var dot = unitAB.x * unitCD.x + unitAB.y * unitCD.y;

			// The dot product of the unit vectors give the cosine of the angle between the 
			// vectors. If this is 1.0, then the lines are parallel and pointing in the same direction
			// If this is -1.0, then the are also parallel, but pointing in the opposite direction
			if (MathUtil.EqualWithinTolerance(dot, 1.0, NORMAL_TOLERANCE))
			{
				// Lines point in the same direction. Return the point (already calculated) that
				// is offsetDistance away.
				offsetVtx = E; //{x:E.x + offsetDistance * unitAB.x, y:E.y + offsetDistance * unitAB.y};
			}
			else if (MathUtil.EqualWithinTolerance(dot, -1.0, NORMAL_TOLERANCE))
			{
				// Lines point in opposite direction. Return undefined
			}
			else
			{
				var v = num/den;
				offsetVtx = {x:E.x + v * unitAB.x, y:E.y + v * unitAB.y};
			}
		}

		return offsetVtx;
	}
	

	//-------------------------------------------------------------------------------------
	//	CalcOffsetPolygon
	//-------------------------------------------------------------------------------------
	var CalcOffsetPolygon = function(inputPolygon, offsetDistance, options)
	{
		var outputPolygon = [];
		var offsetPoly = [];
		var threePoints = [];

		for (var v = 0; v < inputPolygon.length; v++)
		{
			threePoints[0] = inputPolygon[(v == 0) ? (ip.length - 1) : (v-1)];
			threePoints[1] = inputPolygon[v];
			threePoints[2] = inputPolygon[(v+1) % ip.length];	
	
			var offsetAB = (threePoints[0]["offset"] == undefined) ? offsetDistance : threePoints[0]["offset"];
			var offsetBC = (threePoints[1]["offset"] == undefined) ? offsetDistance : threePoints[1]["offset"];
		
			var vtx = CalcOffsetVertex(threePoints, offsetAB, offsetBC);
	
			// Add the offset vertex if one could be computed
			if (vtx != undefined)
			{
				vtx.tag = threePoints[1].tag;
				vtx.inputPtIdx = v; // 2017.11.16
				outputPolygon.push(vtx);
			}
		}

		return outputPolygon;
	}

	//-------------------------------------------------------------------------------------
	//	Corner Bisect Plane
	//-------------------------------------------------------------------------------------
	var CornerBisectPlane = function(ptA, ptB, ptC)
	{
		var plane = {}; // {pt:pt3, n:vec3}
		plane.pt = {x:ptB.x, y:ptB.y, z:ptB.z};
	
		// Unit vectors for each edge
		let unitBA = Math3D.UnitVec3(Math3D.SubVec3Vec3(ptB, ptA));
		let unitBC = Math3D.UnitVec3(Math3D.SubVec3Vec3(ptB, ptC));
	
		// Treat unit vectors as edges of the rhombus, so that
		// add them together will create a new vector that bisects the angle
		let unitBisectB = Math3D.UnitVec3(Math3D.AddVec3ScaledVec3(unitBA, unitBC));
	
		// Find the normal for the plane that contains unitBA and unitBC
		let planeNormalABC = Math3D.CrossProduct(unitBA, unitBC);
	
		// Use the normal of the plane that contains corner ABC to find the 
		// and the vector that bisects ABC to find the normal of the plane
		// that bisects ABC
		plane.n = Math3D.CrossProduct(planeNormalABC, unitBisectB);
	
		return plane;	
	}


	//-------------------------------------------------------------------------------------
	//	API
	//-------------------------------------------------------------------------------------
	return {
		// 3x3 Matrix
		Mat3:			Mat3,
		IdentityMat3:	IdentityMat3,
		RotationMat3:	RotationMat3,
		MultMat3Mat3:	MultMat3Mat3,
		MultMat3Vec3:	MultMat3Vec3,
		DotProduct:		DotProduct,
		CrossProduct:	CrossProduct,
		
		// Vector 
		UnitVec3:		UnitVec3,
		ToUnitVec3:		ToUnitVec3,
		ScaleVec3:		ScaleVec3,
		SubVec3Vec3:	SubVec3Vec3,
		AddVec3ScaledVec3:	AddVec3ScaledVec3,
		LenVec3:		LenVec3,
		InterpolateVec3Vec3:	InterpolateVec3Vec3,
		
		
		// Special functions
		LinePlaneIntersection:	LinePlaneIntersection,
		OrthoPlaneUnitVectors:	OrthoPlaneUnitVectors,
		CornerBisectPlane:		CornerBisectPlane
	};
}());


//-------------------------------------------------------------------------------------
//	Shapes3D
//
//		Solid shapes, as parametric functions or as points, edges, and faces
//-------------------------------------------------------------------------------------
var Shapes3D = (function() {

	//-------------------------------------------------------------------------------------
	//	SpherePt
	//
	//	http://mathworld.wolfram.com/Sphere.html
	//-------------------------------------------------------------------------------------
	function SpherePt(r, s, t)
	{
		var phi   = s * Math.PI;
		var theta = t * Math.PI * 2.0;
	
		var x = r * Math.sin(phi) * Math.cos(theta);
		var y = r * Math.sin(phi) * Math.sin(theta);
		var z = r * Math.cos(phi);
	
		var pt = {x:x, y:y, z:z};
		var nm = {x:x, y:y, z:z};
	
		return {pt:pt, normal:nm};
	}
	
	//-------------------------------------------------------------------------------------
	//	UnitTetrahedron
	//-------------------------------------------------------------------------------------
	function UnitTetrahedron()
	{
		var points =  [];
		var edges = [];
		var faces = [];
	
		points.push({x: Math.sqrt(8/9), y: 0, z: -1/3});
		points.push({x: -Math.sqrt(2/9), y: Math.sqrt(2/3), z: -1/3})
		points.push({x: -Math.sqrt(2/9), y: -Math.sqrt(2/3), z: -1/3})
		points.push({x: 0, y: 0, z: 1});
	
	
	
		edges.push([0, 1], [0, 2], [0, 3]);
		edges.push([1, 2], [2, 3], [3, 1])
	
	
	
		faces.push([0,1,2]);
		faces.push([0,2,3]);
		faces.push([0,3,1]);
		faces.push([3,2,1]);

		return {points:points, edges:edges, faces:faces};
	}

	//-------------------------------------------------------------------------------------
	//	UnitCube
	//-------------------------------------------------------------------------------------
	function UnitCube()
	{
		var points =  [];
		var edges = [];
		var faces = [];
	
		points.push({x: 1, y: 1, z: 1}, {x: 1, y:-1, z: 1}, {x:-1, y:-1, z: 1}, {x:-1, y: 1, z: 1});
		points.push({x: 1, y: 1, z:-1}, {x: 1, y:-1, z:-1}, {x:-1, y:-1, z:-1}, {x:-1, y: 1, z:-1});
	
		points.forEach(Math3D.ToUnitVec3);
	
	
		edges.push([0, 1], [1, 2], [2, 3], [3, 0]);
		edges.push([4, 5], [5, 6], [6, 7], [7, 4]);
		edges.push([0, 4], [1, 5], [2, 6], [3, 7]);
	
	
	
		faces.push([0,1,2,3]);
		faces.push([1,0,4,5]);
		faces.push([2,1,5,6]);
		faces.push([3,2,6,7]);
		faces.push([0,3,7,4]);
		faces.push([7,6,5,4]);

		return {points:points, edges:edges, faces:faces};
	}

	//-------------------------------------------------------------------------------------
	//	UnitOctahedron
	//-------------------------------------------------------------------------------------
	function UnitOctahedron()
	{
		var points =  [];
		var edges = [];
		var faces = [];
	
		points.push({x: 0, y: 0, z: -1});
		points.push({x: 1, y: 0, z: 0}, {x: 0, y: 1, z: 0}, {x:-1, y: 0, z: 0}, {x: 0, y:-1, z: 0});
		points.push({x: 0, y: 0, z: 1});
	
		edges.push([0, 1], [0, 2], [0, 3], [0, 4]);
		edges.push([1, 2], [2, 3], [3, 4], [4, 1]);
		edges.push([5, 1], [5, 2], [5, 3], [5, 4]);
	
		faces.push([0,1,2]);
		faces.push([0,2,3]);
		faces.push([0,3,4]);
		faces.push([0,4,1]);
		faces.push([5,2,1]);
		faces.push([5,3,2]);
		faces.push([5,4,3]);
		faces.push([5,1,4]);

		return {points:points, edges:edges, faces:faces};
	}

	//-------------------------------------------------------------------------------------
	//	UnitIcosahedron
	//-------------------------------------------------------------------------------------
	function UnitIcosahedron()
	{
		var points =  [];
		var edges = [];
		var faces = [];
	
		let phi = (1 + Math.sqrt(5))/2;
	
		points.push({x:0, y: 1, z: phi}, {x: 1, y: phi, z: 0}, {x: phi, y:0, z: 1});
		points.push({x:0, y:-1, z: phi}, {x:-1, y: phi, z: 0}, {x: phi, y:0, z:-1});
		points.push({x:0, y:-1, z:-phi}, {x:-1, y:-phi, z: 0}, {x:-phi, y:0, z:-1});
		points.push({x:0, y: 1, z:-phi}, {x: 1, y:-phi, z: 0}, {x:-phi, y:0, z: 1});
	
		points.forEach(Math3D.ToUnitVec3);
	
	
		edges.push([0, 1], [1, 2], [2, 0]);
		edges.push([0, 4], [0,11], [1, 4], [4, 11], [11, 3]);
		edges.push([0, 3], [2, 3]);
	
		edges.push([9, 5], [9, 6], [9,8], [6,7], [6, 10]);
		edges.push([5, 6], [6, 8], [8, 7], [7, 10], [10, 5]);
	
		//     0
		// 1 2 3 11 4
		//  5 10 7 8 9
		//     6
		edges.push([1, 5], [5, 2], [2, 10], [10, 3], [3, 7])
		edges.push([7, 11], [11, 8], [8, 4], [4, 9], [9, 1]);
	
		faces.push([0,1,2], [0,2,3], [0,3,11], [0,11,4], [0,4,1]);
		faces.push([2,1,5], [3,2,10], [11,3,7], [4,11,8], [1,4,9]);
		faces.push([2,5,10], [3,10,7], [11,7,8], [4,8,9], [1,9,5]);
		faces.push([6,10,5],[6,7,10], [6,8,7], [6,9,8], [6,5,9]);
		
		return {points:points, edges:edges, faces:faces};
	}

	//-------------------------------------------------------------------------------------
	//	
	//-------------------------------------------------------------------------------------
	function UnitDodecahedron()
	{
		var points =  [];
		var edges = [];
		var faces = [];
	
		let phi = (1 + Math.sqrt(5))/2;
	
		points.push({x: 1, y: 1, z: 1}, {x: 1, y: 1, z:-1}, {x: 1, y: -1, z: 1}, {x: 1, y:-1, z:-1});
		points.push({x:-1, y: 1, z: 1}, {x:-1, y: 1, z:-1}, {x:-1, y: -1, z: 1}, {x:-1, y:-1, z:-1});
		points.push({x:0, y:phi, z:1/phi}, {x:0, y:phi, z:-1/phi}, {x:0, y:-phi, z:1/phi}, {x:0, y:-phi, z:-1/phi});
		points.push({x:1/phi, y:0, z:phi}, {x:1/phi, y:0, z:-phi}, {x:-1/phi, y:0, z:phi}, {x:-1/phi, y:0, z:-phi});
		points.push({x:phi, y:1/phi, z:0}, {x:phi, y:-1/phi, z:0}, {x:-phi, y:1/phi, z:0}, {x:-phi, y:-1/phi, z:0});
	
		points.forEach(Math3D.ToUnitVec3);
		
		edges.push([0,8],[8,4],[4,14],[14,12],[12,0]);
		edges.push([1,9],[9,5],[5,15],[15,13],[13,1]);
		edges.push([0,16],[1,16],[8,9]);
		edges.push([13,3],[3,11],[11,7],[7,15]);
		edges.push([4,18],[18,5],[16,17],[17,3]);
		edges.push([7,19],[19,18]);
		edges.push([12,2],[2,17],[14,6],[6,19]);
		edges.push([10,11],[2,10],[10,6]);
		
		faces.push([12,14,4,8,0]);
		faces.push([1,9,5,15,13]);
		faces.push([1,13,3,17,16]);

		faces.push([9,1,16,0,8]);
		faces.push([12,2,10,6,14]);
		faces.push([12,0,16,17,2]);

		faces.push([13,15,7,11,3]);
		faces.push([7,15,5,18,19]);
		faces.push([4,14,6,19,18]);

		faces.push([2,17,3,11,10]);
		faces.push([7,19,6,10,11]);
		faces.push([4,18,5,9,8]);

		return {points:points, edges:edges, faces:faces};
	}

	function UnitTriacontahedron()
	{
		var points =  [];
		var edges = [];
		var faces = [];

		let icosa = UnitIcosahedron();
		let dodeca = UnitDodecahedron();
		
		let s = Math.sqrt((6 + 6/Math.sqrt(5))/(6 + 10/Math.sqrt(5)));
		dodeca.points.forEach(pt => {pt.x *= s; pt.y *= s; pt.z *= s;});
		
		var points = icosa.points.concat(dodeca.points);
		
		edges.push([0,12],[0,24],[0,26],[0,16],[0,20]);
		edges.push([3,26],[3,24],[2,24],[2,12],[1,12],[1,20],[4,20],[4,16],[11,16],[11,26]);
		edges.push([1,21],[21,4],[4,30],[30,11],[11,18],[18,3],[3,14],[14,2],[2,28],[28,1]);
		edges.push([1,13],[21,9],[4,17],[30,8],[11,31],[18,7],[3,22],[14,10],[2,29],[28,5]);
		edges.push([29,5],[5,13],[13,9],[9,17],[17,8],[8,31],[31,7],[7,22],[22,10],[10,29]);

		edges.push([25,9],[9,27],[27,8],[8,19],[19,7],[7,23],[23,10],[10,15],[15,5],[5,25]);
		edges.push([6,15],[6,23],[6,19],[6,27],[6,25]);	
		
		faces.push([13,9,25,5],[6,15,5,25],[6,25,9,27]);
		faces.push([9,17,8,27],[27,8,19,6],[1,13,5,28]);
		faces.push([28,5,29,2],[29,5,15,10],[2,29,10,14]);
		faces.push([23,10,15,6],[7,23,6,19],[7,22,10,23]);
		faces.push([9,13,1,21],[17,9,21,4],[4,21,1,20]);
		faces.push([20,1,12,0],[4,20,0,16],[30,8,17,4]);
		faces.push([4,16,11,30],[0,26,11,16],[0,24,3,26]);
		faces.push([26,3,18,11],[18,3,22,7],[11,18,7,31]);
		faces.push([3,14,10,22],[2,12,1,28],[11,31,8,30]);
		faces.push([0,12,2,24],[24,2,14,3],[31,7,19,8]);
		return {points:points, edges:edges, faces:faces};
	}

	function UnitTriacontahedronCool()
	{
		var points =  [];
		var edges = [];
		var faces = [];

		let icosa = UnitIcosahedron();
		let dodeca = UnitDodecahedron();
		
		let offset = icosa.points.length;
		dodeca.edges.forEach(e => {e[0] += offset, e[1] += offset});
		
		var points = icosa.points.concat(dodeca.points);
		var edges = icosa.edges.concat(dodeca.edges);

		return {points:points, edges:edges, faces:faces};
	}

	//-------------------------------------------------------------------------------------
	//	
	//-------------------------------------------------------------------------------------
	function Torus(config)
	{
		var points =  [];
		var edges = [];
		var faces = [];

		let or = config.outerRadius;
		let ir = config.innerRadius;
		let vs = config.stepsV;
		let us = config.stepsU;
		let va = config.angleV;
		let ua = config.angleU;
	
		let vaInc = Math.PI * 2.0 / vs;
		let uaInc = Math.PI * 2.0 / us;

		for (var vk = 0; vk < vs; vk++)	
		{
			for (var uk = 0; uk < us; uk++)
			{
				let v = va + vaInc * vk;
				let u = ua + uaInc * uk;
			
				let x = (or + ir * Math.cos(v)) * Math.cos(u);
				let y = (or + ir * Math.cos(v)) * Math.sin(u);
				let z = ir * Math.sin(v);
			
				let pt = {x:x, y:y, z:z};
				points.push(pt);
			}
		}
	
		for (var vk = 0; vk < vs; vk++)	
		{
			for (var uk = 0; uk < us; uk++)
			{
				let idx1 = vk * us + uk;
				let idx2 = vk * us + (uk + 1) % us;
				edges.push([idx1, idx2]);
			
				let idx3 = ((vk + 1) % vs) * us + uk;
				edges.push([idx1, idx3]);

				let idx4 = ((vk + 1) % vs) * us + (uk + 1) % us;
				faces.push([idx1, idx2, idx4, idx3]);
			}
		}
	
	
		return {points:points, edges:edges, faces:faces};	
	}

	//-------------------------------------------------------------------------------------
	//	
	//-------------------------------------------------------------------------------------
	function TorusKnot(config)
	{
		var points =  [];
		var edges = [];
		var faces = [];

		let or = config.outerRadius;
		let ir = config.innerRadius;
		let vs = config.stepsV;
		let us = config.stepsU;
		let va = config.angleV;
		let ua = config.angleU;
	
		let vaInc = Math.PI * 2.0 / vs;
		let uaInc = Math.PI * 2.0 / us;

		for (var vk = 0; vk < vs; vk++)	
		{
			for (var uk = 0; uk < us; uk++)
			{
				let v = va + vaInc * vk;
				let u = ua + uaInc * uk;
			
				let a = 1; // xxxx
				let x = (or + ir * Math.cos(v)) * Math.cos(u);
				let y = (or + ir * Math.cos(v)) * Math.sin(u);
				let z = ir * Math.sin(v);
			
				let pt = {x:x, y:y, z:z};
				points.push(pt);
			}
		}
	
		for (var vk = 0; vk < vs; vk++)	
		{
			for (var uk = 0; uk < us; uk++)
			{
				let idx1 = vk * us + uk;
				let idx2 = vk * us + (uk + 1) % us;
				edges.push([idx1, idx2]);
			
				let idx3 = ((vk + 1) % vs) * us + uk;
				edges.push([idx1, idx3]);

				let idx4 = ((vk + 1) % vs) * us + (uk + 1) % us;
				faces.push([idx1, idx2, idx4, idx3]);
			}
		}
	
	
		return {points:points, edges:edges, faces:faces};	
	}


	//-------------------------------------------------------------------------------------
	//	SubdivideEdges
	//-------------------------------------------------------------------------------------
	function SubdivideEdges(inputSolid)
	{
		var outputSolid = JSON.parse(JSON.stringify(inputSolid));
		var initialEdges = outputSolid.edges;
		outputSolid.edges = [];
	
		for (var i = 0; i < initialEdges.length; i++)
		{
			var idxA = initialEdges[i][0];
			var idxB = initialEdges[i][1];
			var ptC = {	x: (outputSolid.points[idxA].x + outputSolid.points[idxB].x)/2,
						y: (outputSolid.points[idxA].y + outputSolid.points[idxB].y)/2,
						z: (outputSolid.points[idxA].z + outputSolid.points[idxB].z)/2 };

			var idxC = outputSolid.points.length;
			outputSolid.points.push(ptC);
			outputSolid.edges.push([idxA, idxC], [idxC, idxB]);
		}
	
		return outputSolid;
	}

	//-------------------------------------------------------------------------------------
	//	UnitSpherifyPoints
	//-------------------------------------------------------------------------------------
	function UnitSpherifyPoints(points)
	{
		for (var i = 0; i < points.length; i++)
		{
			let uv = Math3D.UnitVec3(points[i]);
			points[i].x = uv.x;
			points[i].y = uv.y;
			points[i].z = uv.z;
		}
	}

	//-------------------------------------------------------------------------------------
	//	OrthoPlanePointList
	//-------------------------------------------------------------------------------------
	var OrthoPlanePointList = function(planeNormal, point, polygonPointCount, shapeRadius)
	{
		var orthos = Math3D.OrthoPlaneUnitVectors(planeNormal);
		var orthoAB3s = orthos.s; // {x:-unitAB.y, y:unitAB.x, z:0};
		var orthoAB3t = orthos.t; // {x:0, y:0, z:1.0 /* unit length */};
	
		let normalLen = Math.sqrt(planeNormal.x * planeNormal.x + planeNormal.y * planeNormal.y + planeNormal.z * planeNormal.z);
		var unitAB = {x: planeNormal.x / normalLen, y: planeNormal.y / normalLen, z: planeNormal.z / normalLen};
		//var unitAB = CalcUnitVector3(planeNormal);
		var ptList = [];
		var count = polygonPointCount;
	
		var stepAngle = Math.PI * 2 / count;
		var offsetAngle = Math.PI/polygonPointCount;
	
		var px = point.x;
		var py = point.y;
		var pz = (point.z != undefined) ? point.z : 0;
	
		var d = shapeRadius;
	
		for (var i = 0; i < count; i++)
		{
			var a = i * stepAngle + offsetAngle
			var s = Math.cos(a);
			var t = Math.sin(a);
		
			var nx = s * orthoAB3s.x + t * orthoAB3t.x;
			var ny = s * orthoAB3s.y + t * orthoAB3t.y;
			var nz = s * orthoAB3s.z + t * orthoAB3t.z;
		
			if (unitAB.z == undefined)
				unitAB.z = 0;
			
			var tx = unitAB.y * nz - unitAB.z * ny;
			var ty = unitAB.z * nx - unitAB.x * nz; 
			var tz = unitAB.x * ny - unitAB.y * nx;
		
			var x = px + d * nx;
			var y = py + d * ny; 
			var z = pz + d * nz; 
		
			var pt3 = {x:x, y:y, z:z, nx:nx, ny:ny, nz:nz, tx:tx, ty:ty, tz:tz};
		
			ptList.push(pt3)
		
		}
	
	
		return ptList;
	
	}


	//-------------------------------------------------------------------------------------
	//	API
	//-------------------------------------------------------------------------------------
	return {
		SpherePt:			SpherePt,
		UnitTetrahedron:	UnitTetrahedron,
		UnitCube:			UnitCube,
		UnitOctahedron:		UnitOctahedron,
		UnitIcosahedron:	UnitIcosahedron,
		UnitDodecahedron:	UnitDodecahedron,
		UnitTriacontahedron:	UnitTriacontahedron,
		Torus:				Torus,
		
		SubdivideEdges:		SubdivideEdges,
		UnitSpherifyPoints:	UnitSpherifyPoints,
		
		OrthoPlanePointList:	OrthoPlanePointList
	};
}());

//-------------------------------------------------------------------------------------
//	Projection3D
//
//		projection: "flat", "perspective", "camera", "camera_perspective"
//-------------------------------------------------------------------------------------
function Projection3D()
{
	this.Reset();
}

//-------------------------------------------------------------------------------------
//	Projection3D.Reset
//-------------------------------------------------------------------------------------
Projection3D.prototype.Reset = function()
{
	this.camera = {};
	this.camera.projection = "camera"; 
	this.camera.ax = 0;
	this.camera.ay = 0;
	this.camera.az = 0;
	this.camera.cameraVector = {x:0, y:0, z:1};
	
	this.m = Math3D.IdentityMat3();
}

//-------------------------------------------------------------------------------------
//	Projection3D.Update
//-------------------------------------------------------------------------------------
Projection3D.prototype.UpdateCamera = function(config)
{
	Object.assign(this.camera, config);
	this.CalcCamera();
}

//-------------------------------------------------------------------------------------
//	Projection3D.CalcCamera
//-------------------------------------------------------------------------------------
Projection3D.prototype.CalcCamera = function()
{
	let matax = Math3D.RotationMat3(this.camera.ax * Math.PI/180.0, "x");
	let matay = Math3D.RotationMat3(this.camera.ay * Math.PI/180.0, "y");
	let mataz = Math3D.RotationMat3(this.camera.az * Math.PI/180.0, "z");

	let m = Math3D.MultMat3Mat3(matax, matay);
	this.m = Math3D.MultMat3Mat3(m, mataz);
	
	let v = {x:0, y:0, z:1};
	this.camera.cameraVector = Math3D.MultMat3Vec3(this.m, v);
}

//-------------------------------------------------------------------------------------
//	Projection3D.Map3Dto2D
//-------------------------------------------------------------------------------------
Projection3D.prototype.Map3Dto2D = function(pt3)
{
	var pt2;
	var offset = 400;
	var planeDistance = 300;
	
	
	if (this.camera.projection == "flat")
	{
		pt2 = {x:pt3.x, y:pt3.z};
	}
	else if (this.camera.projection == "perspective")
	{
		var a = pt3.y + offset;
		var d = a /* - planeDistance*/;
	
		var s = d/planeDistance;
	
		pt2 = {x:s*pt3.x, y:s*pt3.z};
	}
	else
	{
		var v = Math3D.MultMat3Vec3(this.m, pt3);
		var a = v.z + offset;
		var d = a /* - planeDistance*/;
	
		var s;
	
		if (this.camera.projection == "camera") // not "camera_perspective"
			s = 1;
		else
			s = d/planeDistance;
			
		pt2 = {x:s*v.x, y:s*v.y};
	}
	
	return pt2;
}


//-------------------------------------------------------------------------------------
//	Enumerations
//
//		
//-------------------------------------------------------------------------------------

// VectorCornerStyle (enum)
var VectorCornerStyle = Object.freeze({
	ANGLE		: 0,
	ARC			: 1,
	QUAD_BEZ	: 2
	});

// BasicUnits (enum)
var BasicUnits = Object.freeze({
	PIXELS		: 0,
	INCHES		: 1,
	MILLIMETERS	: 2
	});

//-------------------------------------------------------------------------------------
//	Basic Units Mgr
//
//		
//-------------------------------------------------------------------------------------
var BasicUnitsMgr = (function() {
	
	var BasicUnitsMgr_GetStr = function(units)
	{
		var unitList = ["pixels", "in", "mm" ];
		var unitStr = "";
		
		// OPTIONAL: Validate the input
		if (units >= 0 && units <= BasicUnits.MILLIMETERS)
			unitStr = unitList[units];
		else
			unitStr = "(??)";
		
		return unitStr;		
	}

	var BasicUnitsMgr_CalcScale = function(units, dpi)
	{
		var scale = 1.0;
		
		if (units == BasicUnits.INCHES)
			scale = dpi;
		else if (units == BasicUnits.MILLIMETERS)
			scale = dpi / 25.4;
			
		return scale;
	}

	return {
		GetStr:					BasicUnitsMgr_GetStr,
		CalcScale:				BasicUnitsMgr_CalcScale
	};
}());
	
var SegmentIntersectionHandling = Object.freeze({
	IGNORE_INTERSECTIONS: 0,
	SUBDIVIDE_SEGMENTS	: 1
});

var PolygonMiterType = Object.freeze({
	BUTT: 		0,
	SQUARE:		1,
	HEX:		2,
	ANGLE_90:	3,
	ANGLE_60:	4
});

// SegmentList (API)
var SegmentList = (function() {
	/*-----------------------------------------------*
	 * Segment List: list of segments that form
	 * one or more polygons
	 * 
	 * {
	 *    vertex:[ {x,y}, {x,y}, ... ]
	 *    segment:[ {a,b}, {a,b}, ... ]
	 * }
	 * x, y: coordinate
	 * a, b: indices into vertex[] array
	 *
	 * Functions:
	 * SegmentList_Validate(): Validates the integrity
	 * of the segment list
	 * SegmentList_ConstructPolygonList(): Converts segment 
	 * list into a list of points describing one or more 
	 * polygons
	 *-----------------------------------------------*/
	var SegDebug_local = function(str)
	{
		//console.log("Segment dbg | " + str);
	}

	
	var SegmentList_Create = function(intersectionHandling = SegmentIntersectionHandling.IGNORE_INTERSECTIONS)
	{
		var segList = { intersectionHandling:intersectionHandling, points:[], segments:[] };
	
		return segList;
	}
	
	var SegmentList_AddClipPolygon = function(segList, pointList)
	{
		// pointList is a closed polygon. When specified all segments will be tested and clipped 
		segList.clipPolygon = pointList;
	}

	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var SegmentList_FindPoint_priv = function(segList, point)
	{
		var index = -1;

		//	var xRound = Math.floor(point.x * 10000)/10000;
		//	var yRound = Math.floor(point.y * 10000)/10000;
		//	var ptRound = {x:xRound, y:yRound};
	
		for (var i = 0; i < segList.points.length && index == -1; i++)
		{
			if (MathUtil.EqualWithinTolerance(segList.points[i].x, point.x, NORMAL_TOLERANCE) && 
				MathUtil.EqualWithinTolerance(segList.points[i].y, point.y, NORMAL_TOLERANCE))
				index = i;
		}
	
		//console.log("FindPoint: " + JSON.stringify(point) + " result:"+ index);
		return index;
	}
	

	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var SegmentList_FindOrAddPoint_priv = function(segList, point)
	{
		var index = SegmentList_FindPoint_priv(segList, point);
	
		if (index == -1)
		{
			segList.points.push(point);
			index = segList.points.length - 1;
			//console.log("Added point: " + JSON.stringify(point) + " at "+ index);

		}
	
		return index;
	}


	var SegmentList_CalcSegmentIntersectionList = function(segList, pointA, pointB)
	{
		//var points = [];
		
		var intersectionList = [];
		
		function compare(a,b) {
		  return (a.c1 - b.c1);
		}
		
		if (segList.intersectionHandling != SegmentIntersectionHandling.IGNORE_INTERSECTIONS)
		{
			for (var i = 0; i < segList.segments.length; i++)
			{
				var s = segList.segments[i];
				var segPtA = segList.points[s.indexA];
				var segPtB = segList.points[s.indexB];
			
				var cPair = MathUtil.CalcSegmentIntersection(pointA, pointB, segPtA, segPtB);
			
				if (cPair != undefined && !MathUtil.EqualWithinTolerance(cPair.c1, intersectionList[intersectionList.length-1], NORMAL_TOLERANCE))
					intersectionList.push({c1:cPair.c1, segIndex:i, c2:cPair.c2});
			}
		}

		if (intersectionList.length == 0)
		{
			intersectionList.push({c1:0.0, segIndex:undefined, c2:undefined});
			intersectionList.push({c1:1.0, segIndex:undefined, c2:undefined});
		}
		else
		{
			// If the start of the line segment is not already in the list, then add it at the beginning
			if (!MathUtil.EqualWithinTolerance(intersectionList[0].c1, 0.0, NORMAL_TOLERANCE))
				intersectionList.unshift({c1:0.0, segIndex:undefined, c2:undefined});

			// If the end of the line segment is not already here, then add it at the end
			if (!MathUtil.EqualWithinTolerance(intersectionList[intersectionList.length-1].c1, 1.0, NORMAL_TOLERANCE))
				intersectionList.push({c1:1.0, segIndex:undefined, c2:undefined});
				
			intersectionList.sort(compare);
		}
		
		//for (var i = 0; i < cList.length; i++)
		//{
		//	var c = cList[i];
		//	var p = {x: pointA.x + c * (pointB.x - pointA.x), y: pointA.y + c * (pointB.y - pointA.y) };
		//	points.push(p);
		//}
		
		//if (cList.length > 2)
		//	console.log(JSON.stringify(cList));
		

		//console.log(JSON.stringify(intersectionList));
		return intersectionList;
	}

	var SegmentList_SplitSegment = function(segList, segIndex, split)
	{
		//console.log("Splitting " + segIndex + " at " + split);
		// Compute a new point that lies on the specified segment
		var seg = segList.segments[segIndex];
		var segPtA = segList.points[seg.indexA];
		var segPtB = segList.points[seg.indexB];
		var newPt = {x:segPtA.x + split * (segPtB.x - segPtA.x), y:segPtA.y + split * (segPtB.y - segPtA.y)};
		
		// Add the new point to the point list
		var ptIndex = SegmentList_FindOrAddPoint_priv(segList, newPt);
		
		// Copy the current segment and set the start point as the new point
		var newSegment = Object.assign({}, seg);
		newSegment.indexA = ptIndex;
		
		// Set the end point of the specified segment as the new point also
		seg.indexB = ptIndex;

		// Add the new segment
		segList.segments.push(newSegment);
	}
	
	var SegmentList_ClipAgainstClipPolygon = function(segList, pointA, pointB)
	{
		var ptPair = undefined;
		var done = false;
		
		var ptAinside = true;
		var ptBinside = true;

		for (var i = 0; i < segList.clipPolygon.length && !done; i++)
		{
			var clipPtA = segList.clipPolygon[i];
			var clipPtB = segList.clipPolygon[(i + 1) % segList.clipPolygon.length];
		
			var cPair = MathUtil.CalcSegmentIntersection(clipPtA, clipPtB, pointA, pointB, true /* always return results */);
		
			if (cPair != undefined)
			{
				if (!cPair.ptCinsideAB)
					ptAinside = false;
					
				if (!cPair.ptDinsideAB)
					ptBinside = false;
					
				if (cPair.ptCinsideAB && cPair.ptDinsideAB)
				{
					// do nothing
				}
				else if (!cPair.ptCinsideAB && !cPair.ptDinsideAB)
				{
					ptPair = {};
					ptPair.ignoreSegment = true;
					done = true;
				}
				else if (cPair.c1 >= 0 && cPair.c1 <= 1.0 && cPair.c2 >= 0 && cPair.c2 <= 1.0)
				{
					var c = cPair.c2;
					var p = {x: pointA.x + c * (pointB.x - pointA.x), y: pointA.y + c * (pointB.y - pointA.y) };
					
					ptPair = {};
					if (cPair.ptCinsideAB)
					{
						ptPair.ptA = pointA;
						ptPair.ptB = p;
					}
					else
					{
						ptPair.ptA = p;
						ptPair.ptB = pointB;
					}
				}
			}
			
			if (!ptAinside && !ptBinside)
			{
				if (ptPair == undefined)
					ptPair = {};
				ptPair.ignoreSegment = true; // NEED TO TEST FOR INTERSECTION
			}
		}
		
		return ptPair;
	}

	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var SegmentList_AddSegment = function(segList, pointA, pointB, segmentOffset = 0, segmentTag)
	{
		var processSegment = true;
		
		if (segList.clipPolygon != undefined)
		{
			var clipResult = MathUtil.ClipSegmentAgainstPolygon(pointA, pointB, segList.clipPolygon);
			if (clipResult != undefined)
			{
				if (clipResult.ignoreSegment)
				{
					processSegment = false;
				}
				else
				{
					pointA = clipResult.ptA;
					pointB = clipResult.ptB;
				}
			}
		}
		
		if (processSegment)
		{
			var intersectionList = SegmentList_CalcSegmentIntersectionList(segList, pointA, pointB);
		
			var angle  = MathUtil.CalcAngle(pointA, pointB);
		
			for (var i = 0; i < intersectionList.length; i++)
			{
				var iInfo = intersectionList[i];
				if (iInfo["segIndex"] != undefined && !MathUtil.EqualWithinTolerance(iInfo.c2, 0.0, NORMAL_TOLERANCE) && !MathUtil.EqualWithinTolerance(iInfo.c2, 1.0, NORMAL_TOLERANCE))
					SegmentList_SplitSegment(segList, iInfo.segIndex, iInfo.c2);
			}
		
			var points = []
			var c = undefined;
			for (var i = 0; i < intersectionList.length; i++)
			{
				if (c == undefined || !MathUtil.EqualWithinTolerance(c, intersectionList[i].c1, NORMAL_TOLERANCE))
				{
					c = intersectionList[i].c1;
					var p = {x: pointA.x + c * (pointB.x - pointA.x), y: pointA.y + c * (pointB.y - pointA.y) };
					points.push(p);
				}
			}
		
			for (var i = 0; i < points.length - 1; i++)
			{
				var ptA = points[i];
				var ptB = points[i + 1];
	
				var indexA = SegmentList_FindOrAddPoint_priv(segList, ptA);
				var indexB = SegmentList_FindOrAddPoint_priv(segList, ptB);
	
				var segment = { indexA:indexA, indexB:indexB, angle:angle };
	
				segment.offset = segmentOffset;
			
				if (segmentTag != undefined)
					segment.tag = segmentTag;
		
				segList.segments.push(segment);
			}
		}
	}

	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var SegmentList_GetSegmentCount = function(segList)
	{
		var count = 0;
	
		if ("segments" in segList)
			count = segList.segments.length;
		else
			Debug_log("SegmentList_GetSegmentCount: 'segments' not defined in segList");
		
		return count;
	}

	/*-----------------------------------------------*
	 * SegmentList: GetSegment
	 * Added so that the segment could be rendered
	 * on-screen (for validation/debugging)
	 *-----------------------------------------------*/
	var SegmentList_GetSegment = function(segList, index)
	{
		var segment;
	
		if (index < segList.segments.length)
		{
			var si = segList.segments[index];
		
			if (si.indexA < segList.points.length && si.indexB < segList.points.length)
			{
				segment = {};
			
				segment.ptA = {x:segList.points[si.indexA].x, y:segList.points[si.indexA].y};
				segment.ptB = {x:segList.points[si.indexB].x, y:segList.points[si.indexB].y};
				if ("tag" in si)
					segment.tag = si.tag;
				if ("offset" in si)
					segment.offset = si.offset;
			}
			else
			{
				Debug_log("SegmentList_GetSegment: point index out of range");
			}
		}
	
		return segment;
	}

	/*-----------------------------------------------*
	 * 
	 *-----------------------------------------------*/
	var SegmentList_GeneratePolygonList = function(segList)
	{
		var SegStringify_priv = function(i)
		{
			var iA = segList.segments[i].indexA;
			var iB = segList.segments[i].indexB;
			var pA = segList.points[iA];
			var pB = segList.points[iB];
			return "segIdx [" + i + "]: (" + iA + "->" + iB + ")  (" + Math.round(pA.x) + "," + Math.round(pA.y) + ") -> (" + Math.round(pB.x) + "," + Math.round(pB.y) + ")";
		}

		var polyList = new PolygonList();
		var done = 0;
	
		SegDebug_local("");
		SegDebug_local("Generate Polygon List");
		
		// Prepare segments for searching
		for (var i = 0; i < segList.segments.length; i++)
			segList.segments[i].used = 0;
	
		do
		{
			var segIndex = -1;
		
			// Find an unused segment
			for (var i = 0; i < segList.segments.length && segIndex == -1; i++)
				if (!segList.segments[i].used)
					segIndex = i;
		

			if (segIndex == -1)
			{
				// No segments, so we are done
				done = 1;
			}
			else
			{
				SegDebug_local("Start poly..." + SegStringify_priv(segIndex));
			
				//console.log("Found start at " + segIndex + ", ptIndexA:" + segList.segments[segIndex].indexA + ", ptIndexB: " + segList.segments[segIndex].indexB);
				// Create a new polygon and add points
				var polySegments = [];
				var cumulativeAngle = 0;
			
				var ptIndexB = segList.segments[segIndex].indexB;
				var segAngle = segList.segments[segIndex].angle;

				// Push first segment
				polySegments.push(segIndex);
			
				// Mark as used
				segList.segments[segIndex].used = 1;

				// Find connecting segments
				var f;
				do
				{
					segIndex = -1;
					var angleDiff = 0;
					for (var i = 0; i < segList.segments.length; i++)
					{
						if (!segList.segments[i].used && segList.segments[i].indexA == ptIndexB)
						{
							var angleDiffToSegI = MathUtil.CalcAngleDiff(segList.segments[i].angle, segAngle);
							if (MathUtil.EqualWithinTolerance(angleDiffToSegI, -Math.PI, ANGLE_TOLERANCE))
								angleDiffToSegI = Math.PI;
								
							SegDebug_local("    testing " + i + "...angle diff: " + MathUtil.r2d(segList.segments[i].angle) + " - " + MathUtil.r2d(segAngle) + " = " + MathUtil.r2d(angleDiffToSegI));
						
							if (segIndex == -1)
							{
								segIndex = i;
								angleDiff = angleDiffToSegI;
							}
							else if (angleDiffToSegI < angleDiff)
							{
								segIndex = i;
								angleDiff = angleDiffToSegI;
							}
						}
					} 
				
				
					// If we found a segment, add it to the polygon
					if (segIndex != -1)
					{
						// Test to determine if we have already completed a closed outside polygon
						// and are about to pick-up a point from an internal polygon.
						// 2017.06.07: Consider using the same test to ALLOW for adding a segment
						// to a closed inside polygon. This would handle the case where there is
						// a single edge (segment pair[s]) connected to the inside polygon 
						// 2017.06.14: Test for closed inside polygon here
						if (polySegments.length > 1)
						{
							// If the point we are about to add is the same as the first point and the cumulative
							// angle is 2Pi, then we have a closed outside polygon
							var firstSeg = polySegments[0];
							var lastSeg  = polySegments[polySegments.length - 1];
							if (segList.segments[firstSeg].indexA == segList.segments[lastSeg].indexB)
							{ 
								var tempAngleDiff = MathUtil.CalcAngleDiff(segList.segments[firstSeg].angle, segList.segments[lastSeg].angle);
								var tempCumulativeAngle = cumulativeAngle + tempAngleDiff;
								SegDebug_local("  previous poly is closed; tempCumulativeAngle: " + MathUtil.r2d(tempCumulativeAngle));
								if (MathUtil.EqualWithinTolerance(tempCumulativeAngle, 2*Math.PI, ANGLE_TOLERANCE))
								{
									SegDebug_local("  poly is outside; angleDiff: " + MathUtil.r2d(angleDiff) + ", tempAngleDiff: " + MathUtil.r2d(tempAngleDiff));
									if (angleDiff > tempAngleDiff)
										segIndex = -1;
								}
								else if (MathUtil.EqualWithinTolerance(tempCumulativeAngle, -2*Math.PI, ANGLE_TOLERANCE))
								{
									SegDebug_local("  poly is inside; angleDiff: " + MathUtil.r2d(angleDiff) + ", tempAngleDiff: " + MathUtil.r2d(tempAngleDiff));
									//segIndex = -1;
									if (angleDiff > tempAngleDiff)
										segIndex = -1;
								}
							}
						}

						// If we still have a segment, then add it to the list
						if (segIndex != -1)
						{
							SegDebug_local("  next at " + SegStringify_priv(segIndex));

							polySegments.push(segIndex);
							segList.segments[segIndex].used = 1;
							ptIndexB = segList.segments[segIndex].indexB;
							segAngle = segList.segments[segIndex].angle;
							cumulativeAngle += angleDiff;
							SegDebug_local("  angle diff: " + MathUtil.r2d(angleDiff) + ", cumulative angle: " + MathUtil.r2d(cumulativeAngle));
					
							// If most recently added point is the same as the first point and the cumulative
							// angle is -2Pi, then we have a closed inside polygon
							// 2017.06.14: Move this test above
							//var firstSeg = polySegments[0];
							//if (polySegments.length > 1 && ptIndexB == segList.segments[firstSeg].indexA)
							//{
							//	angleDiff = MathUtil.CalcAngleDiff(segList.segments[firstSeg].angle, segAngle);
							//	var tempCumulativeAngle = cumulativeAngle + angleDiff;
							//	SegDebug_local("  angle diff: " + MathUtil.r2d(angleDiff) + ", test cumulative angle: " + MathUtil.r2d(tempCumulativeAngle));
							//
							//	if (MathUtil.EqualWithinTolerance(tempCumulativeAngle, -2*Math.PI, ANGLE_TOLERANCE))
							//		segIndex = -1;
							//}
						}
					}
				
				}
				while (segIndex != -1)
			
				// Construct polygon from segments
				var polygon = [];
			
				// Iterate over the list of segments for this polygon
				// and add the first point of each segment
				for (var i = 0; i < polySegments.length; i++)
				{
					segIndex = polySegments[i];
					var ptIndexA = segList.segments[segIndex].indexA;
					
					var pt = {x:segList.points[ptIndexA].x, y:segList.points[ptIndexA].y};
					
					if (segList.segments[segIndex]["tag"] != undefined)
						pt.tag = segList.segments[segIndex].tag;
						
					if (segList.segments[segIndex]["offset"] != undefined)
						pt.offset = segList.segments[segIndex].offset;
						
					polygon.push(pt);
				}
				// If the last point of the last segment does not match the first point of the
				// first segment, then this is an "open polygon"
				// --- TODO: Add "open polygon" support

				// Add to list
				polyList.AddPolygonPoints(polygon);
			}
		}
		while (!done)
	
	
		SegDebug_local("(done: Generate Polygon List)");

		return polyList;
	}

	var SegmentList_FindBounds = function(segList)
	{
		var minx = undefined;
		var miny = undefined;
		var maxx = undefined;
		var maxy = undefined;
		var bounds = undefined;
		
		var p = segList.points;
		for (var j = 0; j < p.length; j++)
		{
			if (minx == undefined)
				minx = p[j].x;
			else if (minx > p[j].x)
				minx = p[j].x;
				
			if (miny == undefined)
				miny = p[j].y;
			else if (miny > p[j].y)
				miny = p[j].y;
				
			if (maxx == undefined)
				maxx = p[j].x;
			else if (maxx < p[j].x)
				maxx = p[j].x;
				
			if (maxy == undefined)
				maxy = p[j].y;
			else if (maxy < p[j].y)
				maxy = p[j].y;
		}
		
		if (minx != undefined && miny != undefined)
			bounds = {min:{x:minx, y:miny}, max:{x:maxx, y:maxy}};
		
		return bounds;
	}
	
	return {
		Create:					SegmentList_Create,
		AddClipPolygon:			SegmentList_AddClipPolygon,
		AddSegment:				SegmentList_AddSegment,
		GetSegmentCount:		SegmentList_GetSegmentCount,
		GetSegment:				SegmentList_GetSegment,
		GeneratePolygonList:	SegmentList_GeneratePolygonList,
		FindBounds:				SegmentList_FindBounds
	};
}());


var Polygon_FindBounds = function(polygonPoints, bounds)
{
	// Find the bounds of one polygon. If the 'bounds' variable is defined,
	// then start with those values, otherwise create a new 'bounds' variable
	//
	if (polygonPoints.length > 0)
	{
		var p = polygonPoints;
		if (bounds == undefined)
			bounds = {min:{x:p[0].x, y:p[0].y}, max:{x:p[0].x, y:p[0].y}}
	
		for (var j = 0; j < p.length; j++)
		{
			if (bounds.min.x > p[j].x)
				bounds.min.x = p[j].x;
				
			if (bounds.min.y > p[j].y)
				bounds.min.y = p[j].y;
				
			if (bounds.max.x < p[j].x)
				bounds.max.x = p[j].x;
				
			if (bounds.max.y < p[j].y)
				bounds.max.y = p[j].y;
		}
	}

	return bounds;
}

	/*-----------------------------------------------*
	 * Polygon List: Calc Offset Vertex
	 * Utility function to calculate a vertex that is
	 * the at the intersection of two lines that are
	 * parallel to the lines AB and BC and a given
	 * distance away.
	 * Returns nil/NULL if the lines AB and BC are
	 * parallel and point in the opposite directions.
	 *-------4----------------------------------------*/
	//var PolygonList_CalcOffsetVertex = function(threePointList, offsetDistanceAB, offsetDistanceBC)
	var PolygonList_CalcOffsetIntersection = function(lineAB, lineCD, offsetDistanceAB, offsetDistanceCD)
	{
		var offsetVtx = undefined;
		var A = lineAB.ptA; //threePointList[0];
		var B = lineAB.ptB; //threePointList[1];
		var C = lineCD.ptA; //threePointList[2];
		var D = lineCD.ptB; //threePointList[2];
	
		var unitAB = MathUtil.CalcUnitVector(A, B);
		var unitCD = MathUtil.CalcUnitVector(C, D);
		
		if (offsetDistanceCD == undefined)
			offsetDistanceCD = offsetDistanceAB;
	
		// MathUtil.CalcUnitVector returns undefined for vectors of zero length
		if (unitAB != undefined && unitCD != undefined)
		{
			var E = {x:(B.x + offsetDistanceAB * unitAB.y), y:(B.y - offsetDistanceAB * unitAB.x)};
			var F = {x:(D.x + offsetDistanceCD * unitCD.y), y:(D.y - offsetDistanceCD * unitCD.x)};
	
			var den = unitAB.y * unitCD.x - unitAB.x * unitCD.y;
			var num = (E.x - F.x) * unitCD.y - (E.y - F.y) * unitCD.x;

			var dot = unitAB.x * unitCD.x + unitAB.y * unitCD.y;
	
			// The dot product of the unit vectors give the cosine of the angle between the 
			// vectors. If this is 1.0, then the lines are parallel and pointing in the same direction
			// If this is -1.0, then the are also parallel, but pointing in the opposite direction
			if (MathUtil.EqualWithinTolerance(dot, 1.0, NORMAL_TOLERANCE))
			{
				// Lines point in the same direction. Return the point (already calculated) that
				// is offsetDistance away.
				offsetVtx = E; //{x:E.x + offsetDistance * unitAB.x, y:E.y + offsetDistance * unitAB.y};
			}
			else if (MathUtil.EqualWithinTolerance(dot, -1.0, NORMAL_TOLERANCE))
			{
				// Lines point in opposite direction. Return undefined
			}
			else
			{
				var v = num/den;
				offsetVtx = {x:E.x + v * unitAB.x, y:E.y + v * unitAB.y};
			}
		}
	
		return offsetVtx;
	}
	
	var PolygonList_CalcOffsetVertex = function(threePointList, offsetDistanceAB, offsetDistanceBC)
	{
		var A = threePointList[0];
		var B = threePointList[1];
		var C = threePointList[2];
		return PolygonList_CalcOffsetIntersection({ptA:A, ptB:B}, {ptA:B, ptB:C}, offsetDistanceAB, offsetDistanceBC);
	}	


	/*-----------------------------------------------*
	 * Calculate a miter point list
	 * The miter in this case is defined as three points,
	 * where the middle point is on the same line as the
	 * line segment from startPt to endPt. The first
	 * and third points are calculated so that the 
	 * internal angles are 120 degrees.
	 *-----------------------------------------------*/
	var PolygonList_CalcMiterPointList = function(miterStartPt, miterEndPt, miterType, offsetAB, offsetBA)
	{
		var miterPtList = [];
		var A = miterStartPt;
		var B = miterEndPt;
	
		if (offsetBA == undefined)
			offsetBA = offsetAB;
			
		var unitAB = MathUtil.CalcUnitVector(A, B);
		
		if (unitAB != undefined)
		{
			var normAB = {x:-unitAB.y, y:unitAB.x};
			
			if (miterType == PolygonMiterType.HEX)
			{
				var radius = (offsetAB + offsetBA) / (Math.sqrt(3.0));
		
				for (var i = 0; i < 3; i++)
				{
					var angle = Math.PI/3 - i * Math.PI/3;
					var cosA = Math.cos(angle);
					var sinA = Math.sin(angle);
			
					var x = B.x + cosA * radius * unitAB.x + sinA * radius * unitAB.y;
					var y = B.y + cosA * radius * unitAB.y - sinA * radius * unitAB.x;

					miterPtList.push({x:x, y:y});
				}
			}
			else if (miterType == PolygonMiterType.BUTT || miterType == PolygonMiterType.SQUARE )
			{
				var squareOffset = 0;
				
				if (miterType == PolygonMiterType.SQUARE)
					squareOffset = (offsetAB + offsetBA) / 2;
					
				var x = B.x - offsetAB * normAB.x + squareOffset * unitAB.x;
				var y = B.y - offsetAB * normAB.y + squareOffset * unitAB.y;
				miterPtList.push({x:x, y:y});

				var x = B.x + offsetBA * normAB.x + squareOffset * unitAB.x;
				var y = B.y + offsetBA * normAB.y + squareOffset * unitAB.y;
				miterPtList.push({x:x, y:y});
			}
			else if (miterType == PolygonMiterType.ANGLE_90 || miterType == PolygonMiterType.ANGLE_60) 
			{
				var angleOffset = 0;
				
				if (miterType == PolygonMiterType.ANGLE_90)
					angleOffset = (offsetAB + offsetBA) / 2;
				else
					angleOffset = (offsetAB + offsetBA) * (Math.sqrt(3.0)/2);
					
				var x = B.x - offsetAB * normAB.x;
				var y = B.y - offsetAB * normAB.y;
				var ptStart = {x:x, y:y};
				
				var x = B.x + offsetBA * normAB.x;
				var y = B.y + offsetBA * normAB.y;
				var ptEnd = {x:x, y:y};
				
				// Handle the case where offsetAB is not equal to offsetBA
				var x = (ptStart.x + ptEnd.x)/2 + angleOffset * unitAB.x;
				var y = (ptStart.y + ptEnd.y)/2 + angleOffset * unitAB.y;
				var ptMid = {x:x, y:y};

				miterPtList.push(ptStart);
				miterPtList.push(ptMid);
				miterPtList.push(ptEnd);
			}
		}
		
		return miterPtList;
	}
	

// Polygon List (API)
	/*-----------------------------------------------*
	 * Polygon List: list of points that form
	 * one or more polygons
	 *
	 * [
	 *    {points:[ {x,y}, {x,y}, {x,y} ... ]},
	 *    {points:[ {x,y}, {x,y}, {x,y} ... ]}
	 *    ...
	 * ] 
	 *
	 * Functions:
	 *
	 * PolygonList_Validate(): Validates the integrity 
	 * of the polygon list
	 *
	 * PolygonList.CalcOffsetPolygon(): Creates a new 
	 * polygon with parallel edges where each edge
	 * is a fixed distance from the corresponding edge
	 * in the input polygon
	 * 
	 *-----------------------------------------------*/

function PolygonList()
{
	this.polygons = [];
}

PolygonList.prototype.GetPolygonCount = function()
{
	return this.polygons.length;
}

PolygonList.prototype.GetPolygonPoints = function(polyIdx)
{
	return this.polygons[polyIdx].points;
}

PolygonList.prototype.AddPolygonPoints = function(polygonPoints)
{
	var poly = {points:polygonPoints};
	
	this.polygons.push(poly);
}

PolygonList.prototype.Translate = function(translatePt)
{
	this.polygons.forEach(pl => pl.points.forEach(pt => { pt.x += translatePt.x; pt.y += translatePt.y }));
}

/*-----------------------------------------------*
 *	Calc Offset Polygon (original)
 *		options:{endCapStyle, cleanUpReversals}
 *-----------------------------------------------*/
PolygonList.prototype.CalcOffsetPolygon = function(offsetDistance, options)
{
	try {
		if (options == undefined || options.useNewRoutine == undefined || options.useNewRoutine)
			return this.CalcOffsetPolygon_v4(offsetDistance, options);
		else
			return this.CalcOffsetPolygon_v1(offsetDistance, options);
	}
	catch (err) {
		console.log("PolygonList.prototype.CalcOffsetPolygon:", err);
	}
}

/*-----------------------------------------------*
 *	Calc Offset Polygon (original)
 *		options:{endCapStyle, cleanUpReversals}
 *-----------------------------------------------*/
PolygonList.prototype.CalcOffsetPolygon_v1 = function(offsetDistance, options)
{
	var inputPolygonList = this;
	var outputPolygonList = new PolygonList();
	var endCapStyle = PolygonMiterType.BUTT;
	if (options == undefined || options.endCapStyle == undefined)
		endCapStyle = PolygonMiterType.BUTT;
	else
		endCapStyle = options.endCapStyle;

	for (var p = 0; p < inputPolygonList.GetPolygonCount(); p++)
	{
		var ip = inputPolygonList.GetPolygonPoints(p);
	
		var offsetPoly = [];
		var threePoints = [];
	
		for (var v = 0; v < ip.length; v++)
		{
			threePoints[0] = ip[(v == 0) ? (ip.length - 1) : (v-1)];
			threePoints[1] = ip[v];
			threePoints[2] = ip[(v+1) % ip.length];	
		
			var offsetAB = (threePoints[0]["offset"] == undefined) ? offsetDistance : threePoints[0]["offset"];
			var offsetBC = (threePoints[1]["offset"] == undefined) ? offsetDistance : threePoints[1]["offset"];
			
			var vtx = PolygonList_CalcOffsetVertex(threePoints, offsetAB, offsetBC);
		
			// Add the offset vertex if one could be computed
			if (vtx != undefined)
			{
				vtx.tag = threePoints[1].tag;
				vtx.inputPtIdx = v; // 2017.11.16
				offsetPoly.push(vtx);
			}
			// We won't find an offset vertex if the lines point in opposite directions.
			// In that case we create a list of points according to the "end cap" style
			else
			{
				var miterVtxList = PolygonList_CalcMiterPointList(threePoints[0], threePoints[1], endCapStyle, offsetAB, offsetBC);
				if (miterVtxList.length > 0)
				{
					for (var i = 0; i < miterVtxList.length; i++)
					{
						miterVtxList[i].tag = threePoints[1].tag;
						offsetPoly.push(miterVtxList[i]);
					}
				}
				else
				{
					console.log("PolygonList_CalcMiterPointList returned zero length");
					offsetPoly.push(threePoints[1]);
				}
			}
		}
		
		// 2019.01.11: Always analyze for inverted segments instead of only when 
		// cleanUpReversals is true
		var invertedCount = 0;
		for (var i = 0; i < offsetPoly.length; i++)
		{
			if (offsetPoly[i].inputPtIdx != undefined)
			{
				// Find the angle between the original line and offset line. Since the angle
				// is calculated from ptA -> ptB, it will have a direction. Therefore, the
				// difference between the lines should be either near zero or near 180 degrees
				var idx = offsetPoly[i].inputPtIdx;
				var srcAngle = MathUtil.CalcAngle(ip[idx], ip[(idx + 1) % ip.length]);
				var newAngle = MathUtil.CalcAngle(offsetPoly[i], offsetPoly[(i+1) % offsetPoly.length]);
				var deltaAngle = MathUtil.CalcAngleDiff(srcAngle, newAngle);
				while (deltaAngle < -0.01)
					deltaAngle += Math.PI * 2;
			
				// If the angle is close to 180 degrees, then the line is considered inverted.
				if (deltaAngle > Math.PI * 0.9)
				{
					offsetPoly[i].inverted = true;
					invertedCount++;
				}
			}
		}

		// 2017.11.16: Clean-up the output polygon, if requested
		var keepPolygon = true;
		if (options != undefined && options.cleanUpReversals)
		{
			
			/////////////////////////////////////////////////
			/////////////////////////////////////////////////
			
			// If no inversions, then nothing to do
			if (invertedCount == 0)
			{
			}
			// If every line if pointing in the opposite direction, then reject the poly
			else if (invertedCount == offsetPoly.length)
			{
				keepPolygon = false;
			}
			// If there are less than three segments pointing in the original direction, then reject
			else if (offsetPoly.length - invertedCount < 3)
			{
				keepPolygon = false;
			}
			// Else, try to remove the inverted lines and find the intersection of the non-inverted lines
			else
			{
				// This algorithm is a mess and needs to be rewritten. For now it works okay for basic cases.
				var done = false;
				var loopLimit = offsetPoly.length;
				var failed = false;
				while (!done && loopLimit-- >= 0 && !failed)
				{
					var nextInvertedIdx = undefined;
					var invertedLen = 0;
					var invertedLenStart = 0;
					var idx = 0;
					
					// Find the next inverted line
					while (nextInvertedIdx == undefined && idx < offsetPoly.length)
					{
						if (offsetPoly[idx].inverted)
							nextInvertedIdx = idx;
						idx++;
					}
					
					if (nextInvertedIdx == undefined)
						done = true;
					else
					{
						// Look for any sequence of inverted lines
						invertedLen = 1;
						while ((nextInvertedIdx + invertedLen) < offsetPoly.length && offsetPoly[nextInvertedIdx + invertedLen].inverted)
							invertedLen++;
						invertedLenStart = invertedLen;
						
						//console.log("nextInvertedIdx:" + nextInvertedIdx + ", invertedLen:" + invertedLen);
						
						var found = false;
						var removeRemaining = false;
						var maxSearchLen = 8;
						var searchLen = 1;
						var searchLenStart = searchLen;
						
						while (!found)
						{
							// Determine if there is an intersection between the two lines before and after the inverted sequence
							var ptA = offsetPoly[(nextInvertedIdx - 1 + offsetPoly.length) % offsetPoly.length];
							var ptB = offsetPoly[nextInvertedIdx];
							var ptC = offsetPoly[(nextInvertedIdx + invertedLen) % offsetPoly.length];
							var ptD = offsetPoly[(nextInvertedIdx + invertedLen + 1) % offsetPoly.length];
						
							var results = MathUtil.CalcSegmentIntersection(ptA, ptB, ptC, ptD, false /*true*/);
						
							//console.log("nextInvertedIdx:" + nextInvertedIdx + ", invertedLen:" + invertedLen + ", results:" + JSON.stringify(results));
							if (results != undefined && results.c1 >= -0.01 && results.c1 <= 1.01 && results.c2 >= -0.01 && results.c2 <= 1.01)
							{
								var ptEx = ptA.x + results.c1 * (ptB.x - ptA.x);
								var ptEy = ptA.y + results.c1 * (ptB.y - ptA.y);
							
								offsetPoly[nextInvertedIdx].x = ptEx;
								offsetPoly[nextInvertedIdx].y = ptEy;
								delete offsetPoly[nextInvertedIdx].inverted;
							
								//if (invertedLen > 2)
								//	console.log("removing points... inverted (i:" + p + ")... offsetPoly.length: " + offsetPoly.length + ", nextInvertedIdx:" + nextInvertedIdx + ", invertedLen:" + invertedLen);

								offsetPoly.splice(nextInvertedIdx + 1, invertedLen);
								
							
								found = true;
							}
							else
							{
								// If the lines did not intersect, then check the next line in the polygon.
								if ((invertedLen + 1 < offsetPoly.length - 1) && (searchLen < maxSearchLen))
								{
									invertedLen++;
									while ((nextInvertedIdx + invertedLen) < offsetPoly.length && offsetPoly[nextInvertedIdx + invertedLen].inverted)
										invertedLen++;
									searchLen++;
									//console.log("  nextInvertedIdx:" + nextInvertedIdx + ", invertedLen:" + invertedLen + ", searchLen:" + searchLen);
								}
								// If the lines after the inverted lines did not intersect the line before the inverted
								// lines, then back up one line and try again
								else
								{
									if (nextInvertedIdx > 0)
									{
										nextInvertedIdx--;
										invertedLenStart++;
										invertedLen = invertedLenStart;
										searchLenStart++;
										searchLen = searchLenStart;
																				
										if (invertedLen + 1 >= offsetPoly.length - 1 || (searchLen >= maxSearchLen))
										{
											found = true;
											// Could not handle the inverted segment
											if (options != undefined && options.logCleanUpReversals)
												console.log("A:failed to handle inverted (i:" + p + ")... offsetPoly.length: " + offsetPoly.length + ", nextInvertedIdx:" + nextInvertedIdx + ", invertedLen:" + invertedLen);
											failed = true;
										}
										else
										{
											//console.log("  nextInvertedIdx:" + nextInvertedIdx + ", invertedLen:" + invertedLen + ", searchLen:" + searchLen);
										}
									}
									else
									{
										found = true;
										// Could not handle the inverted segment
										if (options != undefined && options.logCleanUpReversals)
											console.log("B:failed to handle inverted (i:" + p + ")... offsetPoly.length: " + offsetPoly.length + ", nextInvertedIdx:" + nextInvertedIdx + ", invertedLen:" + invertedLen);
										failed = true;
									}
								}
							}
						}
					}
					//done = true;
				}
				// 2019.01.08: Delete all remaining inverted segments
				if (options != undefined && options.logCleanUpReversals)
				{
					var unprocessedInvertedCount = 0;

					for (var i = 0; i < offsetPoly.length; i++)
						if (offsetPoly[i].inverted)
							unprocessedInvertedCount++;

					if (unprocessedInvertedCount > 0)
						console.log("unprocessedInvertedCount: " + unprocessedInvertedCount);
				}
				
				/*
				for (var i = offsetPoly.length - 1; i > 0; i--)
				{
					if (offsetPoly[i - 1].inverted)
					{
						offsetPoly.splice(i, 1);
					}
				} 
				if (offsetPoly.length < 3)
					keepPolygon = false;
				*/
			}
		}
		
		
		// 2017.11.16: Remove the temporary properties 
		// 2019.01.09: Provide option to retain notes
		if (options != undefined && (options.keepCleanUpReversalsNotes == undefined || !options.keepCleanUpReversalsNotes))
		{
			for (var i = 0; i < offsetPoly.length; i++)
			{
				delete offsetPoly[i].inputPtIdx;
				delete offsetPoly[i].inverted;
			}
		}
	
		// 2017.11.16: Added 'keepPolygon'
		if (keepPolygon)
			outputPolygonList.AddPolygonPoints(offsetPoly);
	}

	return outputPolygonList;
}

/*-----------------------------------------------*
 *	Calc Offset Polygon (version 2)
 *		options:{endCapStyle, cleanUpReversals}
 *-----------------------------------------------*/
PolygonList.prototype.CalcOffsetPolygon_v2 = function(offsetDistance, options)
{
	var inputPolygonList = this;
	var outputPolygonList = new PolygonList();
	
	if (options != undefined && options.logCleanUpReversals)
		console.log("...calc offset poly...");
	
	// Determine the endcap style
	var endCapStyle = PolygonMiterType.BUTT;
	if (options == undefined || options.endCapStyle == undefined)
		endCapStyle = PolygonMiterType.BUTT;
	else
		endCapStyle = options.endCapStyle;

	// Calc the offset polygon for each of the polygons in the list
	for (var p = 0; p < inputPolygonList.GetPolygonCount(); p++)
	{
		var ip = inputPolygonList.GetPolygonPoints(p);
		
		// Start with a list of lines (basically the polygon), where each
		// line will be used to calculate a parallel line. The intersections
		// of consecutive parallel lines will yield the offset polygon
		var parallels = [];
		for (var v = 0; v < ip.length; v++)
		{
			var start = (v + ip.length - 1) % ip.length;
			var end   = (v + 0) % ip.length;
			var s = {idxA:start, idxB:end, include:true};
			parallels.push(s);
		}
		
		var offsetPoly;
		var offsetCalcCompleted = false;
		var offsetCalcPass = 0;
		var keepPolygon = true;
	
		while (!offsetCalcCompleted)
		{
			offsetPoly = [];
			var pstart = 0;
			
			// Find first segment to include
			while (pstart < parallels.length && !parallels[pstart].include)
				pstart++;
				
			while (pstart < parallels.length)
			{
				var pend = pstart + 1;
				var count = 0;
				while (count < parallels.length && !parallels[pend % parallels.length].include)
				{
					pend++;
					count++;
				}				
				
				// Get the info for two parallel lines from the parallels list
				var parAB = parallels[pstart];
				var parCD = parallels[pend % parallels.length];
				
				if (options != undefined && options.logCleanUpReversals)
					console.log("Parallels (" + parAB.idxA + " --> " + parAB.idxB + ") and  (" + parCD.idxA + " --> " + parCD.idxB + ")");
			
				// Create the line objects for the _CalcOffsetIntersection
				var lineAB = {ptA:ip[parAB.idxA], ptB:ip[parAB.idxB]};
				var lineCD = {ptA:ip[parCD.idxA], ptB:ip[parCD.idxB]};
		
				// Get the offset info
				var offsetAB = (lineAB.ptA["offset"] == undefined) ? offsetDistance : lineAB.ptA["offset"];
				var offsetCD = (lineCD.ptA["offset"] == undefined) ? offsetDistance : lineCD.ptA["offset"];
			
				var vtx = PolygonList_CalcOffsetIntersection(lineAB, lineCD, offsetAB, offsetCD);
		
				// Add the offset vertex if one could be computed
				if (vtx != undefined)
				{
					vtx.tag = lineCD.ptA.tag; // or should it be lineAB.ptB?
					vtx.inputPtIdx = parAB.idxB;
					vtx.inputParallelIdx = pstart;
					offsetPoly.push(vtx);
				}
				// We won't find an offset vertex if the lines point in opposite directions.
				// In that case we create a list of points according to the "end cap" style
				else
				{
					var miterVtxList = PolygonList_CalcMiterPointList(lineAB.ptA, lineAB.ptB, endCapStyle, offsetAB, offsetCD);
					if (miterVtxList.length > 0)
					{
						for (var i = 0; i < miterVtxList.length; i++)
						{
							miterVtxList[i].tag = lineAB.ptB.tag; // or should it be lineCD.ptA?;
							offsetPoly.push(miterVtxList[i]);
						}
					}
					else
					{
						console.log("PolygonList_CalcMiterPointList returned zero length");
						offsetPoly.push(lineAB.ptB);
					}
				}
				
				// 
				pstart = pend;
			}
			
			// By default, we only do one pass. This can change if cleanUpReversals is true
			offsetCalcCompleted = true;
			
			// Analyze the results to identify inverted lines.
			// The option to use this to clean-up the result is below.
			var invertedCount = 0;
			
			for (var i = 0; i < offsetPoly.length; i++)
			{
				if (offsetPoly[i].inputPtIdx != undefined)
				{
					// Find the angle between the original line and offset line. Since the angle
					// is calculated from ptA -> ptB, it will have a direction. Therefore, the
					// difference between the lines should be either near zero or near 180 degrees
					var idx = offsetPoly[i].inputPtIdx;
					var srcAngle = MathUtil.CalcAngle(ip[idx], ip[(idx + 1) % ip.length]);
					var newAngle = MathUtil.CalcAngle(offsetPoly[i], offsetPoly[(i+1) % offsetPoly.length]);
					var deltaAngle = MathUtil.CalcAngleDiff(srcAngle, newAngle);
					while (deltaAngle < -0.01)
						deltaAngle += Math.PI * 2;
			
					// If the angle is close to 180 degrees, then the line is considered inverted.
					if (deltaAngle > Math.PI * 0.9)
					{
						offsetPoly[i].inverted = true;
						invertedCount++;
					}
				}
			}

			if (options != undefined && options.cleanUpReversals)
			{
				// If no inversions, then nothing to do
				if (invertedCount == 0)
				{
					offsetCalcCompleted = true;
				}
				// If every line if pointing in the opposite direction, then reject the poly
				else if (invertedCount == offsetPoly.length)
				{
					keepPolygon = false;
					offsetCalcCompleted = true;
				}
				// If there are less than three segments pointing in the original direction, then reject
				// 2019.01.09: Use length of input polygon instead of output polygon, since endcaps add points
				else if (ip.length - invertedCount < 3)
				{
					keepPolygon = false;
					offsetCalcCompleted = true;
				}
				// Else, try to remove the inverted lines and find the intersection of the non-inverted lines
				else
				{
					if (options.logCleanUpReversals)
						console.log("inverted count: " + invertedCount);
					// Identify "runs" of inverted lines
				
					// Look for a non-inverted line first, in case the first entry is in the middle of a run
					var rstart = 0;
					var rlen = 0;
					while (rstart < offsetPoly.length && offsetPoly[rstart].inverted)
						rstart++;

					while (rstart < offsetPoly.length)
					{
						// Look for an inverted line
						while (rstart < offsetPoly.length && !offsetPoly[rstart].inverted)
							rstart++;
					
						// If we found one, then find the length
						if (rstart < offsetPoly.length)
						{
							rlen = 1;
							while (offsetPoly[(rstart + rlen) % offsetPoly.length].inverted && rlen < offsetPoly.length)
								rlen++;
					
							// Remove the inverted lines from the parallels list
							if (rlen == 1)
							{
								var oIdx = (rstart + 1) % offsetPoly.length;
								var pIdx = offsetPoly[oIdx].inputParallelIdx;
								if (pIdx != undefined)
									parallels[pIdx].include = false;
								else
									console.log("Missing inputParallelIdx at ", rstart);
							}
							else
							{
								var shift = 2;
								for (var ii = shift; ii < rlen + shift - 1; ii++)
								{
									var oIdx = (rstart + ii) % offsetPoly.length;
									var pIdx = offsetPoly[oIdx].inputParallelIdx;
									if (pIdx != undefined)
									{
										parallels[pIdx].include = false;
										if (options.logCleanUpReversals)
											console.log("omitting parallel idx: " + pIdx);
									}
									else
										console.log("Missing inputParallelIdx at ", oIdx);
								}
							}						
							// Point to the first non-inverted line after the current run
							rstart += rlen;
						} // if-found-run-start	
					} // while-not-at-end-of-offsetPoly

					//
					offsetCalcPass++;
					offsetCalcCompleted = (offsetCalcPass > 1);
				} // if-else-removeInverted		
			}

		}
		
		
		// 2017.11.16: Remove the temporary properties 
		// 2019.01.09: Provide option to retain notes
		if (options != undefined && (options.keepCleanUpReversalsNotes == undefined || !options.keepCleanUpReversalsNotes))
		{
			for (var i = 0; i < offsetPoly.length; i++)
			{
				delete offsetPoly[i].inputPtIdx;
				delete offsetPoly[i].inverted;
			}
		}
	
		// 2017.11.16: Added 'keepPolygon'
		if (keepPolygon)
			outputPolygonList.AddPolygonPoints(offsetPoly);
			
	}

	return outputPolygonList;
}

/*-----------------------------------------------*
 *	Calc Offset Polygon (version 3)
 *		options:{endCapStyle, cleanUpReversals}
 *-----------------------------------------------*/
PolygonList.prototype.CalcOffsetPolygon_v3 = function(offsetDistance, options)
{
	var inputPolygonList = this;
	var outputPolygonList = new PolygonList();
	
	if (options.logCleanUpReversals)
		console.log("...CalcOffsetPolygon_v3...");
	
	// Determine the endcap style
	var endCapStyle = PolygonMiterType.BUTT;
	if (options == undefined || options.endCapStyle == undefined)
		endCapStyle = PolygonMiterType.BUTT;
	else
		endCapStyle = options.endCapStyle;

	// Calc the offset polygon for each of the polygons in the list
	for (var p = 0; p < inputPolygonList.GetPolygonCount(); p++)
	{
		var ip = inputPolygonList.GetPolygonPoints(p);
		
		// Start with a list of lines (basically the polygon), where each
		// line will be used to calculate a parallel line. The intersections
		// of consecutive parallel lines will yield the offset polygon
		var lines = [];
		for (var v = 0; v < ip.length; v++)
		{
			var start = (v + ip.length - 1) % ip.length;
			var end   = (v + 0) % ip.length;
			var s = {idxA:start, idxB:end, include:true};
			lines.push(s);
		}
		
		var offsetPoly = [];
		var keepPolygon = true;
		var done = false;
		
		while (!done)
		{

			var lnA = 0;
			var lnB = 1;
			var verticesProcessed = 0;
			var vcurrent = 0;
			var consecutiveVtxCount = 0;
			var previousVtxAngle = undefined;
			var foundstart = false; 
			var loopMaxCount = lines.length * 4; // arbitrary
			var loopCount = 0;
			var failureOccurred = false;
		
			while (verticesProcessed < lines.length && loopCount < loopMaxCount && !failureOccurred)
			{
			
				// Get the info for two parallel lines from the lines list
				var parAB = lines[lnA];
				var parCD = lines[lnB % lines.length];
				var advanceLineA = true;
			
				if (options.logCleanUpReversals)
					console.log("Lines (" + parAB.idxA + " --> " + parAB.idxB + ") and  (" + parCD.idxA + " --> " + parCD.idxB + ")");
		
				// Create the line objects for the _CalcOffsetIntersection
				var lineAB = {ptA:ip[parAB.idxA], ptB:ip[parAB.idxB]};
				var lineCD = {ptA:ip[parCD.idxA], ptB:ip[parCD.idxB]};
	
				// Get the offset info
				var offsetAB = (lineAB.ptA["offset"] == undefined) ? offsetDistance : lineAB.ptA["offset"];
				var offsetCD = (lineCD.ptA["offset"] == undefined) ? offsetDistance : lineCD.ptA["offset"];
		
				var vtx = PolygonList_CalcOffsetIntersection(lineAB, lineCD, offsetAB, offsetCD);
			
				var currentVtxAngle = MathUtil.CalcAngleBetweenLines(lineAB, lineCD);
				var currentLineAngle  = MathUtil.CalcAngle(lineAB.ptA, lineAB.ptB);
	
				// Add the offset vertex if one could be computed
				if (vtx != undefined)
				{
					vtx.tag = lineCD.ptA.tag; // or should it be lineAB.ptB?
					vtx.inputPtIdx = parCD.idxA;
					vtx.inputParallelIdx = lnA;
					offsetPoly.push(vtx);
					// Track the number of consecutive (non endCap) vertices
					consecutiveVtxCount++;

					// Check the angle of the previous line once we have at least two vertices
					if (consecutiveVtxCount >= 2)
					{
						var ptA = offsetPoly[offsetPoly.length - 2];
						var ptB = offsetPoly[offsetPoly.length - 1];
						var lineAngle  = MathUtil.CalcAngle(ptA, ptB);
					
						if (options.logCleanUpReversals)
							console.log("Processed:", verticesProcessed, " Line angles:", currentLineAngle.toFixed(3), lineAngle.toFixed(3));
						
						var deltaAngle = MathUtil.CalcAngleDiff(currentLineAngle, lineAngle);
						while (deltaAngle < -0.01)
							deltaAngle += Math.PI * 2;
		
						// If the angle is close to 180 degrees, then the line is considered inverted.
						if (deltaAngle > Math.PI * 0.9)
						{
							if (options.logCleanUpReversals)
								console.log("Processed:", verticesProcessed, " Line angles don't match:", currentLineAngle.toFixed(3), lineAngle.toFixed(3));
							if (!foundstart)
							{
								// If we have not found the start, then discard the (two) vertices found so far.
								offsetPoly = [];
							
								// Mark the line used to find those vertices as "not included"
								lines[lnA].include = false;

								// We discarded both vertices because they were computed using a line that 
								// is now excluded from the search. We will need to compute one of those 
								// vertices again, so we decrement the 'vertices processed' counter
								verticesProcessed--;
							
								// Restart the 'consecutive vertex count'
								consecutiveVtxCount = 0;

								if (options.logCleanUpReversals)
									console.log("  discarding the (two) vertices in offset poly since start not found.");
							}
							else
							{
								// If we have already found the start, then this means that we have valid 
								// points in the offset poly and it is the new point that is causing the 
								// problem, so discard it.
								offsetPoly.splice(offsetPoly.length - 1, 1);
							
								// But if the last point is invalid, it also means that we can't use the line that
								// end with the last point, so we have to back up another point and recompute that
								offsetPoly.splice(offsetPoly.length - 1, 1);
							
								// Also, 
								advanceLineA = false;

								if (options.logCleanUpReversals)
									console.log("  discarding last two vertices in offset poly. Length: " + offsetPoly.length);
							}
						}
						// Line is not inverted
						else
						{
							// If this is the first line we have found pointing in the correct
							// direction, then we have found the 'start' of the offset polygon.
							// ??? why? At this point we reset the verticesProcessed
							if (!foundstart)
							{
								foundstart = true;
								//verticesProcessed = 2;
							}
						}
					}				

					/*
					// Check the angle of the previous vertex once we have at least three vertices
					if (consecutiveVtxCount >= 3)
					{
						var ptA = offsetPoly[offsetPoly.length - 3];
						var ptB = offsetPoly[offsetPoly.length - 2];
						var ptC = offsetPoly[offsetPoly.length - 1];
						var vtxAngle = MathUtil.CalcVertexAngle(ptA, ptB, ptC);
				
						// If the angle does not match the corresponding angle of the input polygon
						// then...??
						if (options.logCleanUpReversals)
							console.log("Processed:", verticesProcessed, " Vertex angles:", previousVtxAngle.toFixed(3), vtxAngle.toFixed(3));
						if (!MathUtil.EqualWithinTolerance(previousVtxAngle, vtxAngle, ANGLE_TOLERANCE))
						{
							console.log("Processed:", verticesProcessed, " Vertex angles don't match:", previousVtxAngle.toFixed(3), vtxAngle.toFixed(3));
						}
					}
					*/
				}
				// We won't find an offset vertex if the lines point in opposite directions.
				// In that case we create a list of points according to the "end cap" style
				else
				{
					var miterVtxList = PolygonList_CalcMiterPointList(lineAB.ptA, lineAB.ptB, endCapStyle, offsetAB, offsetCD);
					if (miterVtxList.length > 0)
					{
						for (var i = 0; i < miterVtxList.length; i++)
						{
							miterVtxList[i].tag = lineAB.ptB.tag; // or should it be lineCD.ptA?;
							offsetPoly.push(miterVtxList[i]);
						}
					}
					else
					{
						console.log("PolygonList_CalcMiterPointList returned zero length");
						offsetPoly.push(lineAB.ptB);
					}
				
					// Reset the 'consecutive vertex count'
					consecutiveVtxCount = 0;
				}
			
				// 
				//pstart = pend;
				//verticesProcessed++;
				loopCount++;
				if (advanceLineA)
				{
					lnA = lnB;
					lnB = (lnB + 1) % lines.length;
					while (!lines[lnB].include  && lnB != lnA)
						lnB = (lnB + 1) % lines.length;
					
					if (lnB == lnA)
					{
						failureOccurred = true;
						console.log("Can't find next vertex because all are marked 'not included'")
					}
				
					verticesProcessed++;
				}
				else
				{
					lnA = (lnA + lines.length - 1) % lines.length;
				}
			
				previousVtxAngle = currentVtxAngle;
			}
		
			// Analyze the results to identify inverted lines.
			// The option to use this to clean-up the result is below.
			var invertedCount = 0;
		
			for (var i = 0; i < offsetPoly.length; i++)
			{
				if (offsetPoly[i].inputPtIdx != undefined)
				{
					// Find the angle between the original line and offset line. Since the angle
					// is calculated from ptA -> ptB, it will have a direction. Therefore, the
					// difference between the lines should be either near zero or near 180 degrees
					var idx = offsetPoly[i].inputPtIdx;
					var srcAngle = MathUtil.CalcAngle(ip[idx], ip[(idx + 1) % ip.length]);
					var newAngle = MathUtil.CalcAngle(offsetPoly[i], offsetPoly[(i+1) % offsetPoly.length]);
					var deltaAngle = MathUtil.CalcAngleDiff(srcAngle, newAngle);
					while (deltaAngle < -0.01)
						deltaAngle += Math.PI * 2;
		
					// If the angle is close to 180 degrees, then the line is considered inverted.
					if (deltaAngle > Math.PI * 0.9)
					{
						offsetPoly[i].inverted = true;
						invertedCount++;
					}
				}
			}

			if (options != undefined && options.cleanUpReversals)
			{
				// If no inversions, then nothing to do
				if (invertedCount == 0)
				{
				}
				// If every line if pointing in the opposite direction, then reject the poly
				else if (invertedCount == offsetPoly.length)
				{
					keepPolygon = false;
				}
				// If there are less than three segments pointing in the original direction, then reject
				// 2019.01.09: Use length of input polygon instead of output polygon, since endcaps add points
				else if (ip.length - invertedCount < 3)
				{
					keepPolygon = false;
				}
				// Else, try to remove the inverted lines and find the intersection of the non-inverted lines
				else
				{
					if (options.logCleanUpReversals)
						console.log("inverted count: " + invertedCount);
					// Identify "runs" of inverted lines
			
				} // if-else-removeInverted		
			}

			done = true;
		} // while-not-done
		
		// 2017.11.16: Remove the temporary properties 
		// 2019.01.09: Provide option to retain notes
		if (options.keepCleanUpReversalsNotes == undefined || !options.keepCleanUpReversalsNotes)
		{
			for (var i = 0; i < offsetPoly.length; i++)
			{
				delete offsetPoly[i].inputPtIdx;
				delete offsetPoly[i].inverted;
			}
		}
	
		// 2017.11.16: Added 'keepPolygon'
		if (keepPolygon)
			outputPolygonList.AddPolygonPoints(offsetPoly);
			
	}

	return outputPolygonList;
}

/*-----------------------------------------------*
 *	Calc Offset Polygon (version 4)
 *		options:{endCapStyle, cleanUpReversals}
 *-----------------------------------------------*/
PolygonList.prototype.CalcOffsetPolygon_v4 = function(offsetDistance, options)
{
	var inputPolygonList = this;
	var outputPolygonList = new PolygonList();
	
	if (options != undefined && options.logCleanUpReversals)
		console.log("...CalcOffsetPolygon_v4...");
	
	// Determine the endcap style
	var endCapStyle = PolygonMiterType.BUTT;
	if (options == undefined || options.endCapStyle == undefined)
		endCapStyle = PolygonMiterType.BUTT;
	else
		endCapStyle = options.endCapStyle;

	// Calc the offset polygon for each of the polygons in the list
	for (var p = 0; p < inputPolygonList.GetPolygonCount(); p++)
	{
		var ip = inputPolygonList.GetPolygonPoints(p);
		
		// Start with a list of lines (basically the polygon), where each
		// line will be used to calculate a parallel line. The intersections
		// of consecutive parallel lines will yield the offset polygon
		var lines = [];
		for (var v = 0; v < ip.length; v++)
		{
			var start = (v + ip.length - 1) % ip.length;
			var end   = (v + 0) % ip.length;
			var s = {idxA:start, idxB:end, include:true};
			lines.push(s);
		}
		
		var offsetPoly;
		var keepPolygon = true;
		var done = false;
		var pass = 1;
		var passMax = Math.min(ip.length - 1, 20 /* arbitrary */);
		var failed = false;
		
		while (!done && pass <= passMax && !failed)
		{
			if (options != undefined && options.logCleanUpReversals)
				console.log("Pass:", pass);
		
			var lnA;
			var lnB;
			
			// Initialize offset polygon
			offsetPoly = [];
			
			// Find the first included line
			lnA = 0;
			while (!lines[lnA].include && lnA < lines.length)
				lnA++;
				
		
			while (lnA < lines.length)
			{
				// Find the next included line
				lnB = lnA + 1;
				while (!lines[lnB % lines.length].include && lnB <= lines.length)
					lnB++;
					
				// Get the info for two parallel lines from the lines list
				var parAB = lines[lnA];
				var parCD = lines[lnB % lines.length];
			
				if (options != undefined && options.logCleanUpReversals)
					console.log("Lines (" + parAB.idxA + " --> " + parAB.idxB + ") and (" + parCD.idxA + " --> " + parCD.idxB + ")");
		
				// Create the line objects for the _CalcOffsetIntersection
				var lineAB = {ptA:ip[parAB.idxA], ptB:ip[parAB.idxB]};
				var lineCD = {ptA:ip[parCD.idxA], ptB:ip[parCD.idxB]};
	
				// Get the offset info
				var offsetAB = (lineAB.ptA["offset"] == undefined) ? offsetDistance : lineAB.ptA["offset"];
				var offsetCD = (lineCD.ptA["offset"] == undefined) ? offsetDistance : lineCD.ptA["offset"];

				// Calculate the vertex
				var vtx = PolygonList_CalcOffsetIntersection(lineAB, lineCD, offsetAB, offsetCD);
			
				// Add the offset vertex if one could be computed
				if (vtx != undefined)
				{
					vtx.tag = lineCD.ptA.tag; // or should it be lineAB.ptB?
					vtx.inputPtIdx = parCD.idxA;
					vtx.inputLinesIdxA = lnA;
					vtx.inputLinesIdxB = (lnB % lines.length);
					offsetPoly.push(vtx);
				}
				// We won't find an offset vertex if the lines point in opposite directions.
				// In that case we create a list of points according to the "end cap" style
				else
				{
					var miterVtxList = PolygonList_CalcMiterPointList(lineAB.ptA, lineAB.ptB, endCapStyle, offsetAB, offsetCD);
					if (miterVtxList.length > 0)
					{
						for (var i = 0; i < miterVtxList.length; i++)
						{
							miterVtxList[i].tag = lineAB.ptB.tag; // or should it be lineCD.ptA?;
							offsetPoly.push(miterVtxList[i]);
						}
					}
					else
					{
						console.log("PolygonList_CalcMiterPointList returned zero length");
						offsetPoly.push(lineAB.ptB);
					}
				}
			
				lnA = lnB;
			}
		
			// Analyze the results to identify inverted lines.
			// The option to use this to clean-up the result is below.
			var invertedCount = 0;
		
			for (var i = 0; i < offsetPoly.length; i++)
			{
				if (offsetPoly[i].inputPtIdx != undefined)
				{
					// Find the angle between the original line and offset line. Since the angle
					// is calculated from ptA -> ptB, it will have a direction. Therefore, the
					// difference between the lines should be either near zero or near 180 degrees
					var idx = offsetPoly[i].inputPtIdx;
					var srcAngle = MathUtil.CalcAngle(ip[idx], ip[(idx + 1) % ip.length]);
					var newAngle = MathUtil.CalcAngle(offsetPoly[i], offsetPoly[(i+1) % offsetPoly.length]);
					var deltaAngle = MathUtil.CalcAngleDiff(srcAngle, newAngle);
					while (deltaAngle < -0.01)
						deltaAngle += Math.PI * 2;
		
					// If the angle is close to 180 degrees, then the line is considered inverted.
					if (deltaAngle > Math.PI * 0.9)
					{
						offsetPoly[i].inverted = true;
						invertedCount++;
					}
				}
			}

			if (options != undefined && options.logCleanUpReversals && invertedCount > 0)
				console.log("inverted count: " + invertedCount);

			// By default, one pass
			done = true;
			
			if (options != undefined && options.cleanUpReversals)
			{
				// If no inversions, then nothing to do
				if (invertedCount == 0)
				{
					done = true;
				}
				// If every line if pointing in the opposite direction, then reject the poly
				else if (invertedCount == offsetPoly.length)
				{
					done = true;
					keepPolygon = false;
				}
				// If there are less than three segments pointing in the original direction, then reject
				// 2019.01.09: Use length of input polygon instead of output polygon, since endcaps add points
				else if (ip.length - invertedCount < 3)
				{
					done = true;
					keepPolygon = false;
				}
				// Else, try to remove the inverted lines and find the intersection of the non-inverted lines
				// But only do that is we are doing another pass, otherwise we are done
				else if (pass < passMax)
				{
					// Try another pass
					done = false;

					// Identify "runs" of inverted lines
					
					// First find a non-inverted line. We do this so we can identify runs that
					// wrap around the end of the offsetPoly array
					var rstart = 0;
					while (rstart < offsetPoly.length && !offsetPoly[rstart].inverted)
						rstart++;
					
					// Count the number of vertices we check.
					var rcount = 0;
					
					while (rcount < offsetPoly.length)
					{
						// If we found an inverted line, then look for a run of inverted lines and select one
						// of the original lines to exclude from the next pass
						if (offsetPoly[rstart].inverted)
						{
							var removedOffset;
							var rlen = 1;
							while (rlen < offsetPoly.length && offsetPoly[(rstart + rlen) % offsetPoly.length].inverted)
								rlen++;
							
							if (options != undefined && options.logCleanUpReversals)
								console.log(" rstart:" + rstart + ", inverted run length: " + rlen + ", (offsetPoly.length: " + offsetPoly.length + ")");
							
							// If the run length is 1 or more than 2, then we remove the first line,
							// otherwise we remove the second line.
							if (rlen == 1 || rlen > 2)
								removedOffset = 0;
							else //if (rlen == 2)
								removedOffset = 1;
						
							var opIdx = (rstart + removedOffset) % offsetPoly.length;
							var lnIdx = offsetPoly[opIdx].inputLinesIdxB;
							
							// If the line is already excluded and we have some other options..
							if (!lines[lnIdx].include)
							{
								if (options != undefined && options.logCleanUpReversals)
									console.log("Line already excluded (opIdx=" + opIdx + ", lnIdx=" + lnIdx + "). Checking another");
									
								if (rlen == 1)
								{
									// failed. Need to exit
									if (options != undefined && options.logCleanUpReversals)
										console.log("Failed to find another line to exclude");
									failed = true;
								}
								else
								{
									if (removedOffset == 0)
										removedOffset = 1;
									else if (removedOffset == 1)
										removedOffset = 0;

									opIdx = (rstart + removedOffset) % offsetPoly.length;
									lnIdx = offsetPoly[opIdx].inputLinesIdxB;
								}
							}
							
							if (!lines[lnIdx].include)
								console.log("Trying to exclude line that is already excluded: opIdx=" + opIdx + ", lnIdx=" + lnIdx);
							
							if (options != undefined && options.logCleanUpReversals)
								console.log(" excluding line:", lnIdx, "(" + lines[lnIdx].idxA + " --> " + lines[lnIdx].idxB + ")");
								
							lines[lnIdx].include = false;
							
							rstart = (rstart + rlen) % offsetPoly.length;
							rcount += rlen;
						}
						// Advance to check the next line
						else
						{
							rstart = (rstart + 1) % offsetPoly.length;
							rcount++;
						}
					}
					
					// Count the remaining lines. If there are less than three, then we 
					// cannot calc a polygon and we are done
					var lnCount = 0;
					for (var i = 0; i < lines.length; i++)
						if (lines[i].include)
							lnCount++;
							
					if (lnCount < 3)
					{
						done = true;
						keepPolygon = false;
					}
			
				} // if-else-removeInverted		
			}

			pass++;
		} // while-not-done
		
		// 2017.11.16: Remove the temporary properties 
		// 2019.01.09: Provide option to retain notes
		if (options != undefined && (options.keepCleanUpReversalsNotes == undefined || !options.keepCleanUpReversalsNotes))
		{
			for (var i = 0; i < offsetPoly.length; i++)
			{
				delete offsetPoly[i].inputPtIdx;
				delete offsetPoly[i].inverted;
				delete offsetPoly[i].inputLinesIdxA;
				delete offsetPoly[i].inputLinesIdxB;
			}
		}
	
		// 2017.11.16: Added 'keepPolygon'
		if (keepPolygon)
			outputPolygonList.AddPolygonPoints(offsetPoly);
			
	} // for-loop-inputpolygonlist

	return outputPolygonList;
}

/*-----------------------------------------------*
 * Combine Parallel Adjacent Lines
 *-----------------------------------------------*/
PolygonList.prototype.CombineParallelAdjacentLines = function()
{
	var bounds = undefined;
	
	for (var k = 0; k < this.GetPolygonCount(); k++)
	{
		var p = this.GetPolygonPoints(k);
		
		var i = 0;
		while (i < p.length)
		{
			var i0 = i;
			var i1 = (i + 1) % p.length;
			var i2 = (i + 2) % p.length;
			
			var vA = {x:(p[i1].x - p[i0].x), y:(p[i1].y - p[i0].y)};
			var vB = {x:(p[i2].x - p[i1].x), y:(p[i2].y - p[i1].y)};
			
			// 2018.01.04: Set near-zero values to zero so Math.sign() tests below
			// work as expected. This addresses the issue where horizontal and vertical
			// lines are not always merged
			if (MathUtil.EqualWithinTolerance(vA.x, 0, NORMAL_TOLERANCE))
				vA.x = 0;
			if (MathUtil.EqualWithinTolerance(vA.y, 0, NORMAL_TOLERANCE))
				vA.y = 0;
			if (MathUtil.EqualWithinTolerance(vB.x, 0, NORMAL_TOLERANCE))
				vB.x = 0;
			if (MathUtil.EqualWithinTolerance(vB.y, 0, NORMAL_TOLERANCE))
				vB.y = 0;
			
			// Instead of vA.y/vA.x == vB.y/vB.x, use vA.y*vB.x == vB.y*vA.x to handle vA.x == 0 or vB.x == 0
			// The sign comparison test determines if the line segments are pointing in the same direction. It is
			// commented-out because it is not accurate if the delta X is very near zero for one and zero for the other
			var equalSlope = MathUtil.EqualWithinTolerance(vA.y * vB.x, vB.y * vA.x, NORMAL_TOLERANCE);
			if (!equalSlope)
				i++;
			else if ( (Math.sign(vA.x) == Math.sign(vB.x)) && (Math.sign(vA.y) == Math.sign(vB.y)))
				p.splice(i1, 1);
			else
				i++;
		}
	}
	
	return bounds;
}
/*-----------------------------------------------*
 * Find Bounds
 * returns: {min:{x:x, y:y}, max:{x:x, y:y}}
 * or undefined if no points in polygon
 *-----------------------------------------------*/
PolygonList.prototype.FindBounds = function()
{
	var bounds = undefined;
	
	for (var i = 0; i < this.GetPolygonCount(); i++)
	{
		var p = this.GetPolygonPoints(i);
		bounds = Polygon_FindBounds(p, bounds);
	}
	
	return bounds;
}


export { BasicUnits, BasicUnitsMgr };
export { MathUtil };
export { Math3D };
export { Shapes3D };
export { Transform };
export { Projection3D };
export { PolygonMiterType };
export { PolygonList, SegmentList, Polygon_FindBounds };
export { SegmentIntersectionHandling };
export { NORMAL_TOLERANCE };
export { VectorCornerStyle };
